var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayThinItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:13:55 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2012, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-ThinItalic",
    horizAdvX: 588
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Thin",
    fontWeight: 250,
    fontStyle: "italic",
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 2 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 519,
    capHeight: 709,
    bbox: "-275 -224 1334 940",
    underlineThickness: 50,
    underlinePosition: -150,
    slope: -12,
    unicodeRange: "U+000D-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 520,
    d: "M139 499h-71l4 20h72l2 11q6 30 19.5 60.5t35 55t51.5 39.5t69 15q32 0 55.5 -9t32.5 -17q26 30 58 48t76 18q24 0 39.5 -5t23.5 -11t11 -11.5t3 -6.5l-18 -12q-2 3 -5 7t-9.5 8.5t-17.5 7.5t-28 3q-39 0 -69.5 -16.5t-52.5 -43t-35.5 -58.5t-19.5 -62l-4 -21h175l-4 -20 h-176l-106 -499h-20l106 499h-177l-106 -499h-20zM340 519q9 50 22 80t33 57q-7 7 -17 12t-21 7.5t-21.5 3.5t-17.5 1q-36 0 -62.5 -15.5t-44.5 -38t-28.5 -48.5t-16.5 -48l-3 -11h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 431,
    d: "M139 499h-71l4 20h72l4 21q6 31 21 66.5t39.5 65t58.5 49t78 19.5q25 0 45 -5t34 -11t21 -11.5t7 -6.5l-18 -12q-7 9 -32 17.5t-62 8.5q-36 0 -65.5 -16.5t-51 -42.5t-35.5 -58t-20 -63l-4 -21h232l-110 -519h-20l106 499h-213l-106 -499h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 498,
    d: "M370 -5q-30 0 -45 17.5t-15 43.5v10.5t2 10.5l114 536q3 12 3 25q0 32 -22.5 57t-75.5 25q-34 0 -61.5 -16t-48 -42t-34 -58t-19.5 -64l-4 -21h118l-5 -20h-118l-106 -499h-20l106 499h-71l4 20h72l4 21q8 41 23.5 77.5t38.5 63.5t54.5 43t70.5 16q57 0 85.5 -27.5 t28.5 -69.5q0 -14 -3 -29l-114 -537q-2 -10 -2 -14q0 -19 11 -34t34 -15q20 0 39.5 4.5t20.5 4.5l5 -19q-1 -1 -23 -5t-47 -4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 628,
    d: "M139 499h-71l4 20h71l2 10q6 30 20 60.5t35.5 55t52 40t69.5 15.5q32 0 55 -9t32 -17q26 30 58 48t77 18q24 0 43.5 -5t33 -11t21 -11.5t7.5 -6.5l-18 -12q-6 9 -32.5 17.5t-56.5 8.5q-39 0 -69.5 -16.5t-52.5 -42.5t-35.5 -58t-19.5 -63l-4 -21h233l-111 -519h-20 l106 499h-213l-106 -499h-20l106 499h-177l-106 -499h-20zM340 519q10 43 22.5 76.5t32.5 60.5q-7 7 -17 12t-21 7.5t-21.5 3.5t-17.5 1q-36 0 -63 -15.5t-45.5 -38t-29.5 -49t-15 -48.5l-2 -10h177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 700,
    d: "M577 -5q-35 0 -50 17.5t-15 43.5v10.5t2 10.5l114 536q3 12 3 24q0 35 -22.5 59t-69.5 24q-37 0 -65.5 -16t-49.5 -41.5t-34.5 -58t-19.5 -64.5l-4 -21h118l-5 -20h-118l-106 -499h-20l106 499h-182l-106 -499h-20l106 499h-71l4 20h71l2 9q8 37 24 68.5t39 54.5t53 36 t68 13q34 0 52 -8.5t27 -16.5q23 30 55 47.5t75 17.5q56 0 84.5 -28t28.5 -70q0 -13 -3 -28l-114 -537q-2 -10 -2 -15q0 -18 11 -33t37 -15q8 0 17.5 1.5t18 3t14.5 3t7 1.5l5 -19q-1 0 -7.5 -1.5t-16.5 -3t-21 -3t-20 -1.5zM345 519q11 48 22 80.5t27 57.5q-13 14 -32 18.5 t-36 4.5q-36 0 -63 -13.5t-47 -35t-32.5 -49t-18.5 -54.5l-2 -9h182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    unicode: "\r",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 255
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 224,
    d: "M81 200l109 517h20l-109 -517h-20zM38 0l18 84h25l-23 -84h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 212,
    d: "M127 570l30 140h20l-30 -140h-20zM175 570l30 140h20l-30 -140h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 623,
    d: "M623 481h-112l-106 -240h129l-4 -20h-134l-97 -221h-21l98 221h-227l-97 -221h-21l98 221h-107l4 20h113l105 240h-129l5 20h134l92 209h21l-94 -209h227l93 209h21l-94 -209h107zM385 241l106 240h-227l-106 -240h227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 589,
    d: "M561 616q-30 47 -69.5 63.5t-99.5 16.5l-71 -332q46 -11 83.5 -23t64.5 -29.5t41.5 -42.5t14.5 -61q0 -50 -20 -89.5t-57 -67t-89 -42t-116 -14.5l-18 -88h-20l19 89q-73 3 -126 29t-92 80l17 13q37 -52 86 -77t118 -29l72 337q-44 9 -78.5 20t-58.5 27t-36.5 39 t-12.5 56q0 50 19.5 90.5t54 69.5t83 45.5t106.5 18.5l22 100h20l-22 -100q64 -1 107.5 -20.5t73.5 -64.5zM504 203q0 60 -46 90.5t-141 51.5l-71 -333q59 0 107 12.5t81.5 36.5t51.5 59.5t18 82.5zM134 495q0 -28 10.5 -47.5t31.5 -34t52.5 -25t74.5 -20.5l70 328 q-64 -2 -109 -18.5t-74 -43.5t-42.5 -63t-13.5 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 644,
    d: "M210 444q-48 0 -76.5 32.5t-28.5 80.5q0 33 14 62.5t37 52t52.5 35.5t60.5 13q47 0 76 -32.5t29 -80.5q0 -33 -14 -62.5t-37 -52t-52.5 -35.5t-60.5 -13zM214 464q27 0 52 11.5t44.5 31t31.5 44.5t12 52q0 41 -26 69t-64 28q-27 0 -52 -11.5t-44.5 -31t-31 -44.5 t-11.5 -52q0 -42 25 -69.5t64 -27.5zM398 -10q-47 0 -76 32.5t-29 80.5q0 33 14 62.5t37 52t52.5 35.5t60.5 13q47 0 76 -32.5t29 -80.5q0 -33 -14 -62.5t-37 -52t-52.5 -35.5t-60.5 -13zM402 10q27 0 52 11.5t44.5 31t31.5 44t12 51.5q0 41 -25.5 69.5t-63.5 28.5 q-27 0 -52 -12t-44.5 -31.5t-31.5 -44.5t-12 -52q0 -41 24.5 -68.5t64.5 -27.5zM-13 11l679 700l13 -12l-679 -700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 668,
    d: "M424 120q-51 -61 -111.5 -95.5t-124.5 -34.5q-37 0 -68 12t-53 34t-34.5 52.5t-12.5 67.5q0 34 11 66t35 63.5t63 62t96 62.5q-34 52 -47.5 84t-13.5 60q0 33 16 62.5t43 52.5t62.5 36.5t74.5 13.5q54 0 95.5 -27.5t63.5 -77.5l-14 -12q-20 47 -58.5 73t-89.5 26 q-34 0 -65 -12t-55 -32.5t-38.5 -47t-14.5 -54.5q0 -27 15 -60t47 -80l181 -259q38 53 66.5 119t42.5 141h120l-4 -20h-98q-17 -75 -46 -140t-69 -117l97 -139h-29zM191 11q60 0 116.5 33.5t104.5 92.5l-177 257q-101 -59 -147 -115.5t-46 -120.5q0 -33 11 -60t30.5 -46.5 t47 -30t60.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 163,
    d: "M127 569l30 141h20l-30 -141h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 228,
    d: "M49 256q0 67 17.5 127.5t47.5 117.5t69.5 112.5t84.5 112.5l13 -12q-35 -41 -72.5 -94.5t-68.5 -112.5t-51 -121.5t-20 -121.5q0 -31 3.5 -66.5t10.5 -72t18 -72.5t25 -67l-18 -12q-29 66 -44 141t-15 141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 228,
    d: "M198 433q0 -118 -57 -228.5t-160 -230.5l-13 12q47 53 85.5 108t66 110.5t42.5 111t15 108.5q0 37 -4 77t-11.5 78.5t-17.5 73.5t-21 61l18 12q24 -67 40.5 -142.5t16.5 -150.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 293,
    d: "M144 564l51 57l-59 22l10 19l59 -22l15 70h19l-15 -70l70 22v-19l-68 -22l28 -57l-19 -12l-27 57l-51 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 410,
    d: "M365 365v-20h-140v-150h-20v150h-140v20h140v150h20v-150h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 257,
    d: "M32 -81l25 71h-9l16 74h25l-16 -74l-27 -71h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 404,
    d: "M59 261l4 20h269l-4 -20h-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 159,
    d: "M8 0l14 64h19l-13 -64h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 531,
    d: "M583 710l-584 -710h-25l584 710h25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 587,
    d: "M227 -10q-41 0 -74 17t-56 47.5t-35.5 73t-12.5 92.5q0 78 25.5 146.5t68 119.5t98 81t115.5 30q42 0 75 -17t56 -47.5t35.5 -73t12.5 -92.5q0 -78 -25.5 -146.5t-68 -120t-98 -81t-116.5 -29.5zM232 10q57 0 108.5 27.5t90.5 75.5t61.5 113t22.5 140q0 47 -11 86 t-32 66.5t-51.5 43t-68.5 15.5q-57 0 -108.5 -28t-90.5 -76t-61.5 -113t-22.5 -140q0 -47 11 -85.5t32 -66.5t51 -43t69 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 353,
    d: "M6 20h135l110 518q-10 -12 -31.5 -26.5t-47 -28t-51.5 -22.5t-45 -9l5 24q26 0 56.5 14.5t57 31.5t44.5 32t19 17h20l-117 -551h121l-4 -20h-276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 477,
    d: "M-7 0q4 18 15 52t35 72.5t64.5 76t103.5 62.5q60 24 101 44t67 41t37.5 46t11.5 59q0 20 -7.5 39.5t-23 34.5t-39.5 24.5t-58 9.5q-35 0 -66 -12t-55 -27t-39.5 -29t-20.5 -19l-13 12l15.5 15t42 32.5t62.5 32.5t78 15q37 0 64.5 -10.5t45.5 -28t26.5 -40t8.5 -46.5 q0 -39 -12.5 -66.5t-40.5 -51t-72.5 -45.5t-108.5 -49q-54 -23 -90.5 -55.5t-59.5 -65.5t-34 -61t-14 -42h352l-5 -20h-371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 490,
    d: "M146 -147q-71 0 -117 34.5t-54 93.5l20 7q5 -52 48 -83.5t109 -31.5q48 0 89 16t70.5 44.5t46.5 68t17 86.5q0 64 -39.5 101.5t-113.5 37.5h-21l4 20h22q98 0 152.5 47t54.5 128q0 60 -38 97t-101 37q-60 0 -112 -31t-82 -82l-16 7q32 57 90 91.5t124 34.5q72 0 114 -42 t42 -107q0 -37 -13 -69.5t-36.5 -58t-56 -42t-70.5 -21.5q55 -8 85 -49t30 -100q0 -51 -19.5 -93.5t-53.5 -74t-79 -49t-96 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 499,
    d: "M319 72h-346l4 17l454 482h14l-102 -479h84l-4 -20h-84l-42 -199h-20zM323 92l94 442l-412 -442h318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 522,
    d: "M159 -149q-72 0 -120 40t-62 106h21q14 -57 58 -91.5t107 -34.5q48 0 94 19t81.5 52.5t57 79.5t21.5 99q0 36 -12 66.5t-33 52.5t-50.5 34t-65.5 12q-54 0 -107 -25t-95 -73h-24q4 9 12.5 30t20 49.5t25 62t27.5 67.5q32 79 71 174h320l-4 -20h-304l-130 -325 q42 39 92 59.5t101 20.5q39 0 71 -13.5t55.5 -37.5t36.5 -57.5t13 -73.5q0 -60 -24.5 -110t-63.5 -86t-89 -56.5t-101 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 581,
    d: "M237 -10q-42 0 -76.5 14.5t-59.5 42t-38.5 67t-13.5 88.5q0 97 25 189.5t70.5 164.5t108.5 115.5t140 43.5q69 0 113.5 -39.5t50.5 -107.5l-20 -7q-3 30 -14.5 54.5t-31 42.5t-45.5 27.5t-57 9.5q-56 0 -105.5 -28.5t-90 -79.5t-70.5 -122.5t-46 -156.5q19 39 47.5 70 t64 52.5t75 33t80.5 11.5t75 -15.5t58 -42.5t37.5 -63t13.5 -78q0 -58 -24.5 -110t-65.5 -91t-93.5 -62t-107.5 -23zM243 10q49 0 96.5 21t85 57t60 83t22.5 99q0 38 -12.5 72t-35.5 59t-54.5 39.5t-68.5 14.5q-50 0 -97.5 -21.5t-84.5 -57.5t-60 -83.5t-23 -98.5 q0 -38 12.5 -71.5t35.5 -58.5t54.5 -39.5t69.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 510,
    d: "M503 563h-404l4 20h438l-497 -710h-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 557,
    d: "M210 -7q-45 0 -79.5 13.5t-58 36t-35.5 53t-12 63.5q0 43 18.5 79.5t47 65t64 48.5t70.5 29q-42 17 -71 51t-29 83q0 46 22 82.5t57 61.5t77.5 38t84.5 13q33 0 63.5 -9.5t53.5 -27.5t37 -44t14 -60q0 -36 -14.5 -65.5t-38 -53t-54 -41t-62.5 -28.5q53 -17 86.5 -59.5 t33.5 -101.5q0 -51 -24 -93t-62.5 -71.5t-88 -46t-100.5 -16.5zM218 10q41 0 84.5 15t79.5 42.5t59.5 66t23.5 85.5q0 36 -15 64t-39.5 47.5t-55.5 30t-63 10.5q-41 0 -84.5 -15t-79.5 -43t-59.5 -66.5t-23.5 -85.5q0 -36 15 -64t39.5 -47.5t55.5 -29.5t63 -10zM297 391 q34 0 72.5 11.5t70.5 34t53 55t21 73.5q0 30 -12.5 53t-33.5 39t-49 24.5t-59 8.5q-39 0 -77 -12t-69 -34.5t-50 -54.5t-19 -72q0 -30 13.5 -53.5t35 -39.5t48.5 -24.5t55 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 565,
    d: "M173 -156q-69 0 -113.5 39.5t-50.5 107.5l20 7q3 -30 14.5 -54.5t31 -42.5t45.5 -27.5t57 -9.5q55 0 105 28.5t90.5 79.5t70.5 122t46 157q-19 -39 -48 -70t-64 -52.5t-75 -33t-80 -11.5q-41 0 -75 15.5t-58 42.5t-37.5 63t-13.5 78q0 58 24.5 110t65.5 91t93 62t108 23 q42 0 76.5 -14.5t59.5 -42t38.5 -67t13.5 -88.5q0 -97 -25 -189.5t-70.5 -164.5t-109 -115.5t-139.5 -43.5zM230 104q49 0 97 21.5t85 57.5t60 83.5t23 98.5q0 38 -12.5 71.5t-35.5 58.5t-54.5 39.5t-69.5 14.5q-50 0 -97 -21t-84.5 -57t-60 -83t-22.5 -99q0 -38 12.5 -72 t35.5 -59t54 -39.5t69 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 155,
    d: "M99 453l14 64h20l-14 -64h-20zM3 0l14 64h19l-13 -64h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 161,
    d: "M102 453l14 64h20l-14 -64h-20zM-14 -81l25 71h-9l16 74h25l-16 -74l-27 -71h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 541,
    d: "M31 268l417 249v-22l-388 -236l388 -237v-22l-417 250v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 453,
    d: "M74 231v20h293v-20h-293zM74 301v20h293v-20h-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 541,
    d: "M492 250l-417 -250v22l388 237l-388 236v22l417 -249v-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 449,
    d: "M142 179q10 48 23 79.5t28 52.5t32.5 33.5t37.5 21.5q30 15 61.5 28.5t58 34.5t43.5 54.5t17 88.5q0 33 -10.5 56.5t-27.5 39.5t-40.5 23.5t-48.5 7.5q-57 0 -113.5 -31.5t-92.5 -85.5l-16 8q20 31 46.5 55t56.5 40.5t61 25t61 8.5t56 -9.5t45.5 -28t31 -46t11.5 -63.5 q0 -58 -18 -94t-46 -59t-62.5 -39t-68.5 -33q-17 -9 -32.5 -19.5t-28.5 -29t-24.5 -47t-20.5 -72.5h-20zM104 0l18 84h20l-18 -84h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 791,
    d: "M540 4q32 0 62 25.5t53.5 67.5t37.5 95t14 108q0 63 -19.5 115.5t-54.5 89.5t-82.5 57.5t-104.5 20.5q-76 0 -148 -35.5t-128 -95t-90 -136t-34 -158.5q0 -61 19.5 -113t54 -90t83 -59.5t105.5 -21.5q73 0 148 38l6 -18q-42 -20 -84.5 -30t-80.5 -10q-59 0 -108.5 23.5 t-85.5 64.5t-56.5 96t-20.5 119q0 58 16.5 113t46 104.5t69.5 91.5t87 72.5t99 47.5t105 17q59 0 110 -21.5t88.5 -61t58.5 -95t21 -122.5q0 -59 -16 -116t-43 -102t-62.5 -73t-75.5 -28q-27 0 -39 14t-12 46q0 8 1 18.5t3 21.5q-34 -33 -78 -52.5t-85 -19.5q-32 0 -58 12.5 t-45 35t-29 54.5t-10 70q0 53 19 101t51.5 84.5t75.5 58t90 21.5t80.5 -22.5t50.5 -64.5l18 88h20l-75 -351q-5 -22 -6 -34t-1 -18q0 -43 39 -43zM325 32q25 0 51.5 8.5t50.5 23t42.5 34t27.5 41.5l40 195q-13 45 -46 69.5t-80 24.5q-42 0 -80.5 -20t-68 -53t-47 -77 t-17.5 -92q0 -33 9 -61.5t25.5 -49t40 -32t52.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 628,
    d: "M184 710h299q30 0 52.5 -12.5t37.5 -32.5t22.5 -46t7.5 -54q0 -33 -10.5 -63.5t-29 -57t-43.5 -47t-54 -33.5q45 -15 68.5 -55.5t23.5 -90.5q0 -43 -18.5 -82.5t-48.5 -69.5t-68 -48t-77 -18h-313zM350 20q35 0 68.5 17t60 44.5t42.5 62.5t16 71q0 27 -7.5 51t-22 42 t-35 29t-46.5 11h-299l-70 -328h293zM404 368q35 0 67.5 17t57 44.5t39.5 62.5t15 70q0 26 -7 49t-20.5 40.5t-33 28t-44.5 10.5h-278l-69 -322h273z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 663,
    d: "M296 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5 q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 684,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    d: "M184 710h434l-4 -20h-414l-67 -316h353l-4 -20h-354l-75 -354h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 701,
    d: "M184 710h20l-72 -337h467l72 337h20l-151 -710h-20l75 353h-467l-75 -353h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 458,
    d: "M105 -11q-85 0 -137 44l14 16q46 -40 127 -40q60 0 101 23.5t68.5 67t46.5 106.5t36 143l77 360h20l-77 -360q-17 -81 -37.5 -147.5t-51 -113.5t-75.5 -73t-112 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 591,
    d: "M184 709h20l-98 -460l526 461h29l-354 -310l216 -400h-26l-208 386l-189 -165l-47 -221h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 552,
    d: "M184 710h20l-147 -690h423l-4 -20h-443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 846,
    d: "M184 710h16l194 -546l426 546h16l-151 -710h-20l141 666l-409 -526h-16l-186 526l-142 -666h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 595,
    d: "M184 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -19 -91.5t-51 -81.5t-74.5 -58.5t-89.5 -22.5h-262l-59 -279h-20zM378 299q44 0 82.5 21t67 54.5t44.5 74.5t16 81q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 725,
    d: "M514 73q-48 -37 -103 -57.5t-112 -20.5q-59 0 -105 24t-77.5 64.5t-48 93.5t-16.5 110q0 82 34 159t90 137t128 96t148 36q59 0 105 -25t77 -66t47 -94t16 -109q0 -48 -12 -95t-34 -90t-52.5 -81t-67.5 -68l48 -87h-25zM303 15q55 0 106 19.5t96 54.5l-53 97h25l45 -83 q35 30 63.5 66.5t49 78t31.5 85t11 86.5q0 55 -16 105t-45.5 88t-72 60.5t-95.5 22.5q-75 0 -143 -36t-120 -94t-82.5 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 574,
    d: "M356 690h-258l4 20h536l-4 -20h-258l-147 -690h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 723,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 644,
    d: "M101 710h21l138 -685l427 685h22l-444 -710h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 986,
    d: "M101 710h22l137 -685l242 389l-59 290h22l52 -266l167 266h22l-183 -290l79 -389l427 685h22l-444 -710h-22l-77 389l-243 -389h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    d: "M292 350l-196 360h26l186 -344l333 344h25l-349 -360l190 -350h-25l-180 334l-323 -334h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 587,
    d: "M-36 20l656 670h-509l5 20h534l-5 -20l-656 -670h510l-4 -20h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 216,
    d: "M23 -40l166 780h67l-4 -20h-48l-157 -740h48l-4 -20h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 480,
    d: "M130 710l262 -710h-25l-263 710h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 215,
    d: "M-20 -40l4 20h48l157 740h-47l4 20h67l-165 -780h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 505,
    d: "M55 303l198 407h18l197 -407h-23l-183 378l-186 -378h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 513,
    d: "M-1 -20l4 20h373l-4 -20h-373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 189,
    d: "M55 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 576,
    d: "M231 -10q-33 0 -60.5 9.5t-49 26t-37 38t-24.5 44.5l-23 -108h-20l155 730h20l-70 -332q51 57 107 93t120 36q46 0 79.5 -19t56 -49t33.5 -68.5t11 -77.5q0 -63 -26 -121t-68 -103t-95.5 -72t-108.5 -27zM233 10q53 0 102.5 26t88 68.5t61.5 96.5t23 111q0 37 -11 72.5 t-32 62.5t-52 43.5t-71 16.5q-34 0 -65 -11.5t-59 -31t-54 -45t-50 -53.5l-46 -225q11 -61 57 -96t108 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 514,
    d: "M219 -10q-42 0 -76.5 17t-59.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16 q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -37.5 -48.5t-53 -39t-62 -26t-64.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 579,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l70 332h21l-147 -687q-1 -3 -1 -5.5v-4.5q0 -13 12 -13l-4 -20q-6 0 -12 2q-16 6 -16 28v3.5t1.5 10l4.5 22.5t9 42 q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 292,
    d: "M139 499h-71l4 20h72l4 21q19 95 65 147.5t108 52.5q27 0 50 -9.5t33 -24.5l-18 -12q-9 12 -27.5 19.5t-40.5 7.5q-54 0 -93.5 -46.5t-56.5 -134.5l-4 -21h146l-4 -20h-147l-151 -712h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 540,
    d: "M172 730h20l-73 -345q22 32 50 58.5t59 45t63.5 28.5t64.5 10q118 0 118 -139q0 -44 -12 -99l-61 -289h-20l61 289q5 27 8.5 51t3.5 44q0 123 -102 123q-35 0 -70.5 -14t-68.5 -38t-60.5 -56.5t-45.5 -70.5l-70 -328h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM172 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 190,
    d: "M-118 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM180 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 521,
    d: "M172 730h20l-83 -390q65 96 135.5 143.5t140.5 47.5q60 0 93 -27.5t33 -77.5q0 -33 -16 -62.5t-45 -53.5t-71 -41.5t-94 -26.5l120 -242h-24l-124 255q113 22 172.5 65t59.5 103q0 42 -28 65.5t-79 23.5q-66 0 -133.5 -48.5t-145.5 -152.5l-66 -311h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 224,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 866,
    d: "M127 519h20l-28 -134q47 68 104.5 105t116.5 37q56 0 87 -35t31 -98v-12t-1 -12q19 38 45.5 67.5t57 49.5t63.5 30t65 10q113 0 113 -131q0 -22 -3 -49t-10 -58l-61 -289h-20l61 289q12 58 12 101q0 117 -98 117q-34 0 -67.5 -13t-63.5 -37t-55.5 -57t-44.5 -73l-69 -327 h-20l61 289q7 31 10 57t3 47q0 114 -97 114q-35 0 -68 -13t-63 -36.5t-56 -56.5t-45 -73l-70 -328h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 577,
    d: "M128 519h19l-23 -110q21 26 47 47.5t54.5 37.5t58.5 24.5t58 8.5q44 0 78.5 -18.5t58.5 -49.5t36.5 -71t12.5 -82q0 -59 -23 -115.5t-63 -101t-93 -72t-113 -27.5q-33 0 -60 10.5t-49 28t-38 41t-26 49.5l-71 -332h-20zM240 10q55 0 104 26.5t85.5 68.5t57.5 94.5 t21 104.5q0 40 -12 77t-34.5 65t-54 44.5t-70.5 16.5q-29 0 -64.5 -13t-68.5 -35t-58.5 -51t-34.5 -60l-40 -187q7 -32 22 -59.5t36.5 -47.5t49.5 -32t61 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 576,
    d: "M208 -10q-44 0 -77.5 18t-56 47.5t-34 68.5t-11.5 81q0 62 26 120t68.5 103t96.5 72t111 27q28 0 54.5 -9t48.5 -25t38.5 -37.5t25.5 -46.5l23 110h20l-147 -692q-1 -1 -1 -7q0 -13 12 -13l-4 -20q-28 0 -28 31q0 8 1 9l62 292q-55 -63 -112.5 -96t-115.5 -33zM212 10 q34 0 67.5 12.5t63.5 33.5t56 48t46 57l43 197q-5 30 -18 57.5t-33.5 47.5t-48 32t-61.5 12q-55 0 -105 -26.5t-88.5 -69t-61.5 -96t-23 -107.5q0 -40 11 -76t32 -63t51.5 -43t68.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 281,
    d: "M119 -5q-31 0 -51 17t-20 46q0 4 0.5 8t1.5 9l90 424h-71l4 20h72l38 181h20l-38 -181h118l-4 -20h-119l-80 -373q-6 -28 -8.5 -40.5t-2.5 -19.5q0 -25 16 -38t39 -13q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16l-8 -5t-21.5 -10t-31 -9.5t-36.5 -4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-27 0 -27 30q0 1 0.5 5t2.5 14.5t6 30t11 52.5q-23 -33 -51.5 -59 t-60.5 -44.5t-66 -28.5t-67 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 451,
    d: "M64 519h21l78 -491q49 55 90.5 118t75 127.5t59 127t43.5 118.5h20q-41 -131 -109 -263t-177 -256h-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 723,
    d: "M61 519h21l88 -491q58 63 105 134.5t84 143.5l-38 213h21l32 -182q23 48 41.5 94t32.5 88h20q-17 -54 -39 -108t-49 -108l50 -275q51 55 94 118t78 127.5t61.5 127t44.5 118.5h20q-42 -131 -112.5 -263t-183.5 -256h-18l-49 273q-38 -70 -85.5 -138.5t-107.5 -134.5h-18z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 456,
    d: "M206 258l-142 261h26l127 -234l5 -12l237 246h26l-253 -261l141 -258h-26l-126 232l-5 12l-234 -244h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 457,
    d: "M-32 20l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 217,
    d: "M204 720l-65 -304q-1 -5 -7.5 -23.5t-24.5 -32.5q6 -7 8 -16t2 -18q0 -8 -1 -14t-1 -8l-67 -315h53l-5 -20h-50q-6 0 -11 4t-5 15q0 7 1 11l65 305q2 10 2 17q0 11 -4.5 19.5t-16.5 10.5l4 20q10 0 17 6t11.5 13.5t6.5 15t3 10.5l63 294q4 20 13.5 25t14.5 5h50l-4 -20 h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 254,
    d: "M122 -130v905h20v-905h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 218,
    d: "M140 720l4 20h50q3 0 10 -3.5t7 -17.5q0 -6 -1 -9l-63 -294q-2 -6 -2 -17q0 -10 4 -19t17 -9l-4 -20q-17 -2 -26.5 -17t-12.5 -30l-64 -305q-4 -17 -12.5 -23.5t-16.5 -6.5h-50l4 20h52l67 315q1 5 8 23.5t24 32.5q-6 8 -8 17t-2 17q0 16 2 22l65 304h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 442,
    d: "M56 251q0 1 4.5 14t15 28t26 27t38.5 12q20 0 38.5 -9.5t36.5 -21t36 -21t38 -9.5q18 0 31 7.5t22 17.5t13 18.5t4 10.5l20 -1q-5 -12 -12 -25t-17.5 -23.5t-25.5 -17.5t-35 -7q-24 0 -44 9.5t-38 21t-34.5 21t-32.5 9.5q-15 0 -27 -9.5t-20.5 -20.5t-12.5 -20.5 t-4 -10.5h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 255
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 224,
    d: "M168 517l-110 -517h-20l110 517h20zM210 717l-17 -84h-25l22 84h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 522,
    d: "M175 -120l24 111q-40 3 -71.5 23t-53 50t-32.5 68t-11 78q0 57 23 112.5t61.5 100t89.5 73t108 31.5l25 118h19l-25 -118q37 -1 64 -10t46 -24.5t31 -36t19 -45.5l-21 -7q-16 52 -53.5 76.5t-89.5 26.5l-106 -497q23 0 52 7.5t57 22t51.5 34.5t34.5 45l19 -6 q-16 -30 -42 -53t-56 -38.5t-61.5 -23.5t-58.5 -8l-24 -110h-19zM51 212q0 -38 10.5 -73t30.5 -62.5t48 -45t63 -20.5l105 496q-56 -3 -103 -31.5t-81 -71t-53.5 -93.5t-19.5 -99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 446,
    d: "M64 366h103q-11 41 -24.5 77.5t-13.5 76.5q0 39 17 74.5t44 62t62 42.5t71 16q48 0 83 -28.5t49 -76.5l-19 -12q-14 45 -45.5 71t-73.5 26q-31 0 -60.5 -13.5t-53 -37t-38 -54.5t-14.5 -65q0 -40 14 -78t25 -81h166l-5 -20h-157q3 -14 5 -29t2 -31q0 -31 -5 -58 t-22.5 -56.5t-50 -66t-87.5 -87.5q16 3 34 5t35 2q22 0 39 -3t32.5 -7t31 -7t33.5 -3q20 0 43 5t55 16l2 -19q-56 -22 -105 -22q-21 0 -38 3t-33 7t-33 7t-38 3q-20 0 -45.5 -3.5t-46.5 -8.5l-6 17q63 57 99.5 95t55.5 67t24 54t5 57q0 31 -8 63h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 551,
    d: "M160 467q23 23 53.5 35.5t65.5 12.5q36 0 67.5 -13.5t54.5 -36.5l70 69l15 -14l-71 -70q19 -24 30 -53.5t11 -61.5t-11.5 -62t-31.5 -54l73 -71l-15 -14l-72 71q-24 -23 -54.5 -35.5t-65.5 -12.5t-64.5 12t-52.5 33l-69 -68l-15 14l70 69q-44 50 -44 118q0 33 11 63 t31 54l-68 68l15 14zM125 334q0 -33 12 -62t33 -50.5t49 -34t60 -12.5t60.5 13t49.5 35t33.5 51t12.5 62t-12.5 62.5t-33.5 51t-49.5 34t-60.5 12.5q-31 0 -59 -12.5t-49 -34.5t-33.5 -51.5t-12.5 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 627,
    d: "M368 341h88l-4 -20h-101l-39 -46l-5 -24h130l-4 -20h-130l-50 -231h-20l50 231h-130l4 20h130l5 26l-18 44h-102l5 20h89l-154 369h23l172 -412l348 412h23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 248,
    d: "M139 285v-415h-20v415h20zM139 775v-415h-20v415h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 468,
    d: "M346 181q33 -23 33 -75q0 -47 -21 -83.5t-53.5 -61t-70.5 -37t-72 -12.5q-61 0 -98 24t-62 58l18 13q30 -38 64.5 -56.5t82.5 -18.5q31 0 64.5 11.5t61.5 33t46 52.5t18 70q0 28 -11.5 45.5t-30 27.5t-41.5 13.5t-47 4.5q-31 1 -58 8t-47.5 22t-32 37.5t-11.5 54.5 q0 36 17 69.5t38 53.5q-17 12 -26 36.5t-9 53.5q0 46 21 81.5t52.5 59.5t69 36.5t70.5 12.5q31 0 54.5 -5t40 -14.5t28 -23.5t19.5 -32l-20 -8q-5 19 -18.5 31.5t-31.5 19.5t-38 9.5t-38 2.5q-31 0 -64 -11.5t-60.5 -33t-45.5 -52.5t-18 -70q0 -56 37 -79t96 -23 q30 0 57.5 -6.5t48.5 -21t34 -37t13 -54.5q0 -36 -17 -70.5t-42 -55.5zM98 312q0 -32 12.5 -51t32 -30t45 -16t51 -8t49 -6t40.5 -11q24 18 40.5 49.5t16.5 63.5q0 29 -12.5 49t-32.5 32t-44 17t-48 5q-28 0 -53 4.5t-45 14.5q-21 -17 -36.5 -47.5t-15.5 -65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 227,
    d: "M40 653l16 77h20l-16 -77h-20zM151 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 836,
    d: "M429 -7q-78 0 -144 27.5t-114 76t-75.5 114.5t-27.5 144q0 77 27.5 143t75.5 114t114 75.5t144 27.5t144 -27.5t114 -75.5t75.5 -114t27.5 -143q0 -78 -27.5 -144t-75.5 -114.5t-114 -76t-144 -27.5zM430 13q72 0 133.5 24.5t107.5 69.5t72 107.5t26 137.5 q0 74 -25.5 137t-71 108.5t-107.5 71.5t-135 26q-74 0 -136 -25.5t-108 -71.5t-71.5 -108.5t-25.5 -135.5t25.5 -135.5t71 -108t108 -71.5t136.5 -26zM436 127q-38 0 -77 15t-70.5 44.5t-51.5 72t-20 96.5q0 40 12.5 81t38 74.5t65.5 54.5t95 21q56 0 103 -24t67 -75l-19 -7 q-12 27 -30.5 44t-40 26.5t-43 12.5t-37.5 3q-50 0 -86 -19.5t-59 -50t-34.5 -68t-11.5 -73.5q0 -50 18.5 -88.5t47 -65t63 -40.5t66.5 -14q22 0 45.5 6.5t45.5 18t39.5 28.5t26.5 38l19 -5q-4 -13 -18 -31.5t-36.5 -35t-52.5 -28t-65 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 404,
    d: "M171 351q-42 0 -67 25.5t-25 63.5q0 27 13 49t35.5 37.5t52.5 24.5t65 9q61 0 105 -19l7 35q3 15 3 28q0 37 -21.5 58.5t-63.5 21.5q-51 0 -119 -41l-8 20q76 46 134 46q52 0 80 -25t28 -73q0 -9 -1 -18.5t-3 -19.5l-36 -171q-1 -1 -1 -6q0 -10 11 -10l-6 -29 q-17 0 -25.5 4.5t-8.5 18.5q0 5 1 7l5 29q-30 -31 -71 -48t-84 -17zM182 377q23 0 48 6t46.5 17t36.5 25.5t19 31.5l13 61q-23 11 -48 15t-53 4q-58 0 -96.5 -24.5t-38.5 -67.5q0 -29 20 -48.5t53 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 497,
    d: "M36 268l261 169l-5 -22l-239 -156l173 -157l-5 -22l-189 170zM198 268l262 169l-5 -22l-240 -156l173 -157l-4 -22l-189 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 540,
    d: "M478 338l-42 -198h-20l38 178h-364l4 20h384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 519,
    d: "M59 261l4 20h384l-4 -20h-384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 836,
    d: "M429 -7q-78 0 -144 27.5t-114 76t-75.5 114.5t-27.5 144q0 77 27.5 143t75.5 114t114 75.5t144 27.5t144 -27.5t114 -75.5t75.5 -114t27.5 -143q0 -78 -27.5 -144t-75.5 -114.5t-114 -76t-144 -27.5zM429 13q72 0 134 24.5t108 69.5t72 108t26 140q0 73 -25.5 135 t-71 107.5t-108 71.5t-135.5 26t-135.5 -26t-108 -71.5t-71 -107.5t-25.5 -135q0 -74 25.5 -136.5t71 -108t107.5 -71.5t136 -26zM284 583h188q28 0 52 -12t41.5 -32t27 -45t9.5 -51q0 -27 -8.5 -51.5t-24 -43.5t-37.5 -31t-48 -14l117 -182h-24l-116 182h-156v-182h-21v462 zM477 323q26 0 45.5 9.5t33 26t20 38.5t6.5 46t-8 46t-22.5 38t-35 25.5t-44.5 9.5h-167v-239h172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 361,
    d: "M46 686l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 245,
    d: "M180 586q-23 0 -38 15.5t-15 38.5q0 15 6.5 30t18 27t26.5 19.5t32 7.5q23 0 38 -16.5t15 -40.5q0 -16 -7 -30.5t-18.5 -26t-26.5 -18t-31 -6.5zM185 606q9 0 19.5 4.5t19 12.5t14 18.5t5.5 22.5q0 20 -10.5 28.5t-27.5 8.5q-22 0 -38.5 -16t-16.5 -39q0 -17 9 -28.5 t26 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 483,
    d: "M77 85v20h300v-20h-300zM377 365v-20h-140v-150h-20v150h-140v20h140v150h20v-150h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 354,
    d: "M67 423q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5t-69 22.5q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12.5 12.5t31.5 22.5t47.5 22t62.5 10q55 0 80 -26.5t25 -62.5t-17 -59.5t-42.5 -38.5t-54 -24t-52.5 -17 q-40 -14 -65.5 -32t-40.5 -37t-21.5 -38t-9.5 -34h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 363,
    d: "M205 418q-60 0 -90.5 27t-30.5 69l17 7q0 -41 28.5 -62.5t79.5 -21.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33 55t-91 20h-21l4 18h21q70 0 108.5 23t38.5 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48t82.5 18q53 0 84.5 -26 t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 188,
    d: "M53 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 580,
    d: "M136 519h21l-62 -291q-12 -56 -12 -97q0 -121 104 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h21l-102 -479q-1 -1 -1 -7q0 -13 12 -13l-5 -20q-27 0 -27 30q0 8 1 10l20 92q-23 -33 -52 -59t-61 -44.5t-65.5 -28.5t-66.5 -10q-103 0 -117 104l-65 -306h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 541,
    d: "M64 433q0 62 23 113t65 87.5t101.5 56.5t133.5 20h192l-5 -20h-66l-164 -770h-20l70 328h-86l-70 -328h-20l70 328q-108 2 -166 50.5t-58 134.5zM84 438q0 -44 16.5 -75t44.5 -51.5t66 -31t81 -12.5l90 422q-71 0 -126.5 -18.5t-93.5 -51.5t-58 -79.5t-20 -102.5z M488 690h-86l-90 -422h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 155,
    d: "M56 250l18 83h19l-17 -83h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 239,
    d: "M4 -125q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l71 94l15 -11l-44 -57q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 240,
    d: "M250 441l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 431,
    d: "M223 351q-30 0 -54.5 11.5t-42 31.5t-26.5 46.5t-9 56.5q0 42 17.5 80t46.5 67.5t66.5 47t77.5 17.5q30 0 55 -11.5t43 -31.5t27.5 -47t9.5 -57q0 -41 -18 -79.5t-47 -67.5t-67.5 -46.5t-78.5 -17.5zM227 370q34 0 67.5 15.5t59.5 41.5t42 60t16 72q0 27 -8.5 51 t-24 41.5t-37 27.5t-47.5 10q-33 0 -66 -15.5t-59 -41.5t-42 -60.5t-16 -72.5q0 -27 8.5 -50.5t23.5 -41t36 -27.5t47 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 497,
    d: "M443 250l-261 -170l4 22l240 157l-173 156l4 22l190 -169zM281 250l-262 -170l5 22l240 157l-174 156l5 22l189 -169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 710,
    d: "M30 11l679 700l13 -12l-679 -700zM240 361l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74zM560 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM564 129l47 219 l-241 -219h194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 754,
    d: "M7 11l679 700l13 -12l-679 -700zM246 361l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74zM380 0q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5 t-69 22.5q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12.5 12.5t31.5 22.5t47.5 22t62.5 10q56 0 80.5 -26.5t24.5 -62.5t-17 -59.5t-42.5 -38.5t-54 -24t-52.5 -17q-40 -14 -65.5 -32t-40.5 -37t-21.5 -38t-9.5 -34h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 729,
    d: "M66 11l679 700l13 -12l-679 -700zM572 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM576 129l47 219l-241 -219h194zM189 338q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5 t11.5 38.5q0 35 -33.5 55t-90.5 20h-21l4 18h21q70 0 108.5 23t38.5 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5 t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 445,
    d: "M284 327q-10 -48 -23 -79.5t-28 -52.5t-33 -33.5t-37 -21.5q-30 -15 -61.5 -28.5t-58 -34.5t-43.5 -54.5t-17 -88.5q0 -33 10.5 -56.5t27.5 -39.5t40 -23.5t49 -7.5q57 0 113.5 31.5t92.5 85.5l16 -8q-20 -31 -46.5 -55t-56.5 -40.5t-61 -25t-61 -8.5t-56 9.5t-45.5 28 t-31 46t-11.5 63.5q0 58 18 94t46 59t62.5 39t68.5 33q17 9 32.5 19.5t28.5 29t24.5 47t20.5 72.5h20zM322 506l-18 -84h-20l18 84h20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM386 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM428 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM346 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM497 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7 t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM374 841l16 77h20l-16 -77h-20zM485 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM389 850q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM453 902q-18 0 -33 -13.5 t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 921,
    d: "M511 710h440l-5 -20h-414l-67 -317h363l-5 -20h-363l-70 -333h422l-4 -20h-443l54 254h-266l-212 -254h-25zM424 274l85 404l-340 -404h255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 660,
    d: "M199 -125q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l58 78q-56 2 -99 28t-73 67t-45.5 94t-15.5 109q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66 t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-25 -39 -59.5 -68.5t-73 -50.5t-79 -32.5t-78.5 -12.5l-39 -52q11 4 22.5 5t19.5 1 q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM368 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM398 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM338 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM361 841l16 77h20l-16 -77h-20zM472 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM159 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM209 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM126 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM154 841l16 77h20l-16 -77h-20zM265 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 691,
    d: "M51 367h67l73 343h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217l74 347h-67zM261 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-69 -323h182l-4 -20h-183 l-69 -327h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM554 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5 t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM425 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM466 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM385 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM535 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13 t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM412 841l16 77h20l-16 -77h-20zM523 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 460,
    d: "M372 135l-15 -14l-135 135l-135 -135l-14 15l134 134l-135 136l15 14l135 -135l136 136l14 -15l-136 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 726,
    d: "M680 710l-59 -72q37 -42 56.5 -98.5t19.5 -118.5q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36q-48 0 -87.5 16t-69.5 44l-45 -55h-25l57 69q-38 42 -57 98.5t-19 119.5q0 82 34 159t90 137t127.5 96t147.5 36q48 0 87.5 -17t69.5 -46l47 58h25zM72 290 q0 -60 17.5 -113t52.5 -91l452 549q-29 28 -65.5 44t-81.5 16q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 59 -18 111.5t-52 90.5l-452 -549q29 -27 66 -42t82 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM427 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM445 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM383 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM410 841l16 77h20l-16 -77h-20zM521 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20zM374 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 574,
    d: "M184 710h20l-32 -150h236q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -19 -91.5t-51 -81.5t-74.5 -58.5t-89.5 -22.5h-243l-27 -129h-20zM327 149q44 0 82.5 21t67 54.5t44.5 74.5t16 81q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-235l-83 -391h242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 523,
    d: "M159 13q66 1 118.5 17.5t89 45.5t55.5 70.5t19 93.5q0 69 -42 111t-117 42h-16l4 20h15q36 0 68 13t57 35t39.5 51.5t14.5 63.5q0 51 -34 84.5t-91 33.5q-35 0 -66.5 -13t-57 -37.5t-43.5 -58.5t-27 -76l-108 -509h-20l108 509q10 46 30.5 84t49.5 65t64.5 41.5 t74.5 14.5q32 0 58 -10t44.5 -27.5t28.5 -41.5t10 -52q0 -31 -13 -61t-34 -54t-48 -41t-55 -23q63 -14 95 -56t32 -103q0 -113 -79.5 -179.5t-227.5 -71.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM328 730h32 l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM341 645 l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM269 656 l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM417 663 q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM295 653 l16 77h20l-16 -77h-20zM406 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM309 662 q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM373 714q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 883,
    d: "M137 -10q-34 0 -59.5 10.5t-42.5 28.5t-25.5 41.5t-8.5 49.5q0 40 18.5 72.5t51 55.5t76.5 36t94 13q34 0 68.5 -5.5t63.5 -14.5q7 26 18 51t25 48q0 60 -33 95.5t-92 35.5q-39 0 -83.5 -16.5t-92.5 -47.5l-8 16q56 35 101 51.5t87 16.5q58 0 96.5 -31.5t43.5 -92.5 q43 56 102 90t122 34q41 0 76 -15t60.5 -41.5t40 -63t14.5 -79.5q0 -17 -2.5 -40.5t-10.5 -39.5h-450q-3 -23 -3 -42q0 -42 12 -78t34.5 -62.5t54 -41t70.5 -14.5q28 0 57 8t55.5 22.5t49 34.5t37.5 44l18 -5q-16 -27 -40.5 -49.5t-54.5 -39t-62.5 -26t-64.5 -9.5 q-62 0 -106.5 33t-65.5 88q-22 -33 -52.5 -56t-64 -37.5t-66.5 -21t-58 -6.5zM143 10q31 0 67 9.5t68.5 26.5t57.5 40t34 51q-8 30 -8 62q0 27 6 57q-30 11 -63.5 16t-65.5 5q-48 0 -88 -11t-69 -31t-45 -48t-16 -63q0 -22 7 -42.5t22 -36.5t38 -25.5t55 -9.5zM821 268 q7 27 7 57q0 35 -10.5 68t-32 58.5t-54 40.5t-75.5 15q-44 0 -86 -18t-77 -50t-62 -76t-40 -95h430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 514,
    d: "M123 -126q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l56 75q-39 3 -71 21t-54.5 47.5t-35 68t-12.5 82.5q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5 q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -36.5 -47.5t-50.5 -38t-59.5 -26.5t-62.5 -11l-37 -48q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52 t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM330 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM330 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM274 656l104 74h16l73 -74l-18 -12 l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM295 653l16 77h20l-16 -77h-20z M406 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM92 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM161 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM67 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM100 653l16 77h20l-16 -77h-20zM211 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 568,
    d: "M534 699l-104 -63q54 -65 74 -133t20 -134q0 -88 -27.5 -158.5t-71.5 -119.5t-99 -75t-110 -26q-42 0 -77 16t-60 43t-38.5 63.5t-13.5 77.5q0 57 25.5 108.5t66.5 90.5t93.5 62.5t106.5 23.5q37 0 68 -10.5t55 -30t39.5 -46t21.5 -58.5q3 30 3 60q0 58 -18.5 117.5 t-71.5 120.5l-134 -81l-7 14l130 79q-20 23 -46 45t-58 45h29q27 -20 49 -40.5t41 -41.5l107 65zM47 192q0 -38 12.5 -71t35 -58t54.5 -39t70 -14q50 0 98.5 23t87 60.5t62 86.5t23.5 100q0 36 -13 68t-36.5 56t-55.5 37.5t-70 13.5q-50 0 -98 -21.5t-85.5 -58t-61 -84 t-23.5 -99.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM414 663q-21 0 -35.5 6 t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM324 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM351 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM264 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM412 663q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13 t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM287 653l16 77h20l-16 -77h-20zM398 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 548,
    d: "M257 385v64h20v-64h-20zM257 92v64h20v-64h-20zM66 261v20h403v-20h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 561,
    d: "M89 44q-28 30 -43.5 72t-15.5 91q0 63 26 121t68.5 102.5t96 70.5t108.5 26q32 0 60 -11t51 -31l27 34h25l-38 -48q28 -30 43.5 -72t15.5 -91q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5q-33 0 -61 10.5t-51 29.5l-24 -30h-24zM50 209q0 -45 13.5 -83 t39.5 -66l323 408q-42 39 -101 39q-50 0 -99.5 -24.5t-88.5 -66t-63 -95.5t-24 -112zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 45 -14 83t-39 66l-324 -407q21 -17 46.5 -27t55.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-27 0 -27 30q0 1 0.5 5t2.5 14.5t6 30t11 52.5q-23 -33 -51.5 -59 t-60.5 -44.5t-66 -28.5t-67 -10zM275 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM315 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM245 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM274 653l16 77h20l-16 -77h-20zM385 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5zM276 645l-13 12 l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 576,
    d: "M168 710h20l-66 -312q50 57 106.5 93t122.5 36q45 0 78 -17.5t55.5 -46t33.5 -65.5t11 -77q0 -57 -21.5 -116t-60.5 -107t-93 -78t-118 -30q-68 0 -111.5 33t-64.5 85l-68 -321h-20zM243 10q49 0 96.5 24t85 66t60.5 97.5t23 118.5q0 41 -10.5 76t-31 60.5t-50.5 40 t-69 14.5q-35 0 -68 -12t-62.5 -32.5t-56 -48t-47.5 -58.5l-40 -187q-2 -6 -2 -9.5v-5.5q0 -30 14.5 -56.5t38.5 -46t55 -30.5t64 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5zM228 653l16 77h20 l-16 -77h-20zM339 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM313 874l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM236 686 l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM438 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM359 670 q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 647,
    d: "M485 -159q-19 5 -28.5 18.5t-9.5 30.5q0 28 21 53.5t75 60.5l-50 250h-351l-159 -254h-22l445 710h18l142 -710q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37zM489 274l-80 407l-255 -407h335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 580,
    d: "M367 -159q-19 5 -28.5 18.5t-9.5 30.5q0 14 5 27t16.5 27t30.5 29.5t47 33.5q-8 7 -8 22q0 2 0.5 5t2 10.5l4.5 22.5t8 41q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27 q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5 t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 663,
    d: "M296 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5 q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5zM474 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 514,
    d: "M219 -10q-42 0 -76.5 17t-59.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16 q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -37.5 -48.5t-53 -39t-62 -26t-64.5 -9.5zM329 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 663,
    d: "M296 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5 q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5zM392 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 514,
    d: "M219 -10q-42 0 -76.5 17t-59.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16 q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -37.5 -48.5t-53 -39t-62 -26t-64.5 -9.5zM271 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 663,
    d: "M296 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5 q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5zM478 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 514,
    d: "M219 -10q-42 0 -76.5 17t-59.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16 q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -37.5 -48.5t-53 -39t-62 -26t-64.5 -9.5zM352 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 663,
    d: "M296 -6q-58 0 -103.5 25t-76.5 67t-47.5 96t-16.5 111q0 72 30 147t84 136t127.5 99.5t160.5 38.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-81 0 -149.5 -36.5t-118.5 -94.5t-78 -129.5t-28 -140.5 q0 -57 16.5 -107.5t46.5 -88.5t73 -60.5t96 -22.5q33 0 70 9t73.5 27t70.5 46.5t62 67.5l18 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5zM397 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 514,
    d: "M219 -10q-42 0 -76.5 17t-59.5 47t-38.5 70t-13.5 86q0 64 25 122t67 101t96.5 68.5t112.5 25.5q63 0 105 -30.5t56 -85.5l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16 q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-14 -26 -37.5 -48.5t-53 -39t-62 -26t-64.5 -9.5zM276 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 684,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM364 906l18 12l68 -63l94 63 l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 579,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l70 332h21l-147 -687q-1 -3 -1 -5.5v-4.5q0 -13 12 -13l-4 -20q-6 0 -12 2q-16 6 -16 28v3.5t1.5 10l4.5 22.5t9 42 q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM614 657 l76 73h33l-96 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 691,
    d: "M51 367h67l73 343h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217l74 347h-67zM261 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-69 -323h182l-4 -20h-183 l-69 -327h197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 579,
    d: "M433 653h117l17 77h21l-17 -77h72l-4 -20h-72l-126 -593q-1 -2 -1 -7q0 -13 12 -13l-4 -20q-15 0 -21.5 8.5t-6.5 21.5q0 7 1 10l14 68q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101 t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l49 235h-117zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44 t70.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM302 874l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM238 686l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM429 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM364 670q20 0 39 17.5t27 42.5h18 q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM423 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM353 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-198q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37l-16 -17q-19 5 -28.5 18.5t-9.5 30.5q0 27 19.5 51.5t69.5 58.5h-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 521,
    d: "M162 -168q-19 5 -28.5 18.5t-9.5 30.5q0 26 19 50.5t68 58.5q-43 2 -76.5 20t-56.5 48t-35 69t-12 83q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64 t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37t37.5 49l19 -6q-31 -55 -85.5 -90t-116.5 -41q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5 t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM340 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM273 718l18 12l68 -63l94 63l13 -12 l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20zM375 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM261 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20zM469 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM351 670q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20zM462 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM343 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20zM244 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM381 730l-22 -58h9l-13 -59h-25l12 59l25 58h14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 701,
    d: "M184 710h20l-72 -337h467l72 337h20l-151 -710h-20l75 353h-467l-75 -353h-20zM370 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 540,
    d: "M172 730h20l-73 -345q22 32 50 58.5t59 45t63.5 28.5t64.5 10q118 0 118 -139q0 -44 -12 -99l-61 -289h-20l61 289q5 27 8.5 51t3.5 44q0 123 -102 123q-35 0 -70.5 -14t-68.5 -38t-60.5 -56.5t-45.5 -70.5l-70 -328h-20zM284 656l104 74h16l73 -74l-18 -12l-68 63 l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 709,
    d: "M112 574h47l29 136h20l-29 -136h467l29 136h20l-29 -136h47l-4 -20h-47l-118 -554h-20l75 353h-467l-75 -353h-20l118 554h-48zM603 373l38 181h-467l-38 -181h467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 540,
    d: "M86 653h69l17 77h20l-17 -77h120l-4 -20h-120l-52 -248q22 32 50 58.5t59 45t63.5 28.5t64.5 10q118 0 118 -139q0 -44 -12 -99l-61 -289h-20l61 289q12 54 12 95q0 123 -102 123q-35 0 -70.5 -14t-68.5 -38t-60.5 -56.5t-45.5 -70.5l-70 -328h-20l134 633h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM274 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21 t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM213 663q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21 t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM95 874l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM30 686l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM216 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM161 670q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 215,
    d: "M-27 -159q-19 5 -28.5 18.5t-9.5 30.5q0 14 5.5 27.5t17.5 27.5t31 29.5t47 34.5l149 700h20l-151 -709q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -30 34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 183,
    d: "M-43 -159q-19 5 -28.5 18.5t-9.5 30.5q0 14 5.5 27.5t17.5 27.5t31 29.5t47 34.5l108 510h20l-110 -519q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37zM173 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM211 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 672,
    d: "M184 709h20l-151 -709h-20zM319 -11q-85 0 -137 44l14 16q46 -40 127 -40q60 0 101 23.5t68.5 67t46.5 106.5t36 143l77 360h20l-77 -360q-17 -81 -37.5 -147.5t-51 -113.5t-75.5 -73t-112 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 372,
    d: "M127 519h20l-110 -519h-20zM172 730h20l-16 -77h-20zM64 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM362 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 458,
    d: "M105 -11q-85 0 -137 44l14 16q46 -40 127 -40q60 0 101 23.5t68.5 67t46.5 106.5t36 143l77 360h20l-77 -360q-17 -81 -37.5 -147.5t-51 -113.5t-75.5 -73t-112 -26zM375 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 182,
    d: "M-126 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM64 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 591,
    d: "M184 709h20l-98 -460l526 461h29l-354 -310l216 -400h-26l-208 386l-189 -165l-47 -221h-20zM186 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 521,
    d: "M172 730h20l-83 -390q65 96 135.5 143.5t140.5 47.5q60 0 93 -27.5t33 -77.5q0 -33 -16 -62.5t-45 -53.5t-71 -41.5t-94 -26.5l120 -242h-24l-124 255q113 22 172.5 65t59.5 103q0 42 -28 65.5t-79 23.5q-66 0 -133.5 -48.5t-145.5 -152.5l-66 -311h-20zM137 -167l22 58 h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 484,
    d: "M127 519h20l-68 -323l403 321h27l-258 -206l153 -311h-24l-147 297l-160 -128l-36 -169h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 552,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM213 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 224,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5zM187 779l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 552,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM202 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 224,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5zM40 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 552,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM255 657l76 73h33l-96 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 217,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5zM233 657l76 73h33l-96 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 552,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM334 360l18 83h19l-17 -83h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 239,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5zM195 250l18 83h19l-17 -83h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 560,
    d: "M18 236l89 76l85 398h20l-80 -377l218 188l10 -15l-234 -201l-61 -285h423l-4 -20h-443l60 284l-73 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 238,
    d: "M21 318l101 87l70 325h20l-65 -304l107 92l12 -14l-125 -107l-68 -320q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 25.5 2.5t28.5 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5q-29 0 -44.5 16t-15.5 44v10.5t2 11.5l63 299l-84 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM478 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM343 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM266 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM167 -167l22 58h-9l13 59h25 l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM407 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM265 718l18 12l68 -63l94 63 l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM59 730l-96 -85l-13 12l49 47 l8 26h52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 744,
    d: "M419 -170q-28 0 -50.5 7t-37.5 27l18 12q14 -16 34 -21t40 -5q19 0 40.5 9t40 24t32.5 36t19 45l7 32l-366 675l-143 -671h-20l151 710h15l369 -681l145 680h20l-158 -745q-6 -29 -23 -53.5t-39 -42.5t-47 -28t-47 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 540,
    d: "M238 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l69 325q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20l110 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5 q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-69 -325q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM349 874l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM229 686l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM475 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5 t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM354 670q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5 t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM397 833l-13 12l76 73h33zM493 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM274 645l-13 12l76 73h33zM370 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1149,
    d: "M301 -5q-60 0 -106 24.5t-78 65t-48.5 93.5t-16.5 110q0 81 34 158t90 137t128 96t148 36q54 0 96.5 -19t73 -52t49 -76.5t23.5 -92.5l50 235h435l-5 -20h-414l-67 -317h363l-5 -20h-363l-70 -333h422l-4 -20h-443l50 234q-27 -50 -64.5 -94t-82.5 -76t-94.5 -50.5 t-100.5 -18.5zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-45.5 88t-72 60.5t-95.5 22.5q-75 0 -143 -36t-120 -94t-82.5 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1000,
    d: "M213 -10q-41 0 -75 16.5t-58 45.5t-37 68t-13 84q0 65 26 123.5t68 103t96 70.5t111 26q39 0 71.5 -14t56.5 -39.5t37.5 -61.5t14.5 -80q19 45 47.5 81t63.5 61.5t74.5 39t81.5 13.5q88 0 135.5 -59.5t47.5 -162.5q0 -31 -2 -41.5t-4 -15.5h-450q-3 -21 -3 -40 q0 -42 13 -78.5t37 -63t57 -41.5t73 -15q30 0 59.5 8t55.5 22.5t48 34.5t37 44l18 -5q-17 -27 -42 -50t-55 -39.5t-62.5 -25.5t-64.5 -9q-40 0 -74.5 14.5t-60.5 40.5t-41.5 62t-18.5 78q-21 -44 -50.5 -80t-65 -61.5t-74.5 -39.5t-78 -14zM218 10q51 0 100.5 24t88.5 65 t62.5 94.5t23.5 113.5q0 42 -12 78.5t-34 63.5t-53 42.5t-68 15.5q-51 0 -100.5 -24.5t-88.5 -66t-63 -95.5t-24 -114q0 -42 12 -78t34 -62.5t53 -41.5t69 -15zM939 268q2 12 3 24t1 24q0 42 -12 77.5t-34 60.5t-53.5 39t-69.5 14q-44 0 -86 -18t-77 -50t-62 -76t-40 -95 h430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM393 836 l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM223 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM199 -167 l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM-25 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM342 909l18 12 l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM159 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5zM392 855l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5zM291 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5zM326 866l104 74h16l73 -74l-18 -12 l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5zM216 656l104 74h16l73 -74l-18 -12l-68 63 l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 581,
    d: "M150 -125q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l59 78q-79 2 -135 28t-98 82l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27 t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43 t15 -61.5q0 -48 -18.5 -87t-53 -66t-83 -42.5t-108.5 -17.5l-40 -52q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 450,
    d: "M61 -130q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l59 79q-52 2 -91.5 22t-65.5 61l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16 t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5 t11.5 -43.5q0 -37 -16 -68t-43.5 -53.5t-66 -36t-83.5 -14.5l-40 -52q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5zM336 928l18 12l68 -63l94 63l13 -12 l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5zM219 718l18 12l68 -63l94 63l13 -12 l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 573,
    d: "M117 -125q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l67 89l146 684h-258l4 20h536l-4 -20h-258l-147 -690l-44 -57q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 281,
    d: "M21 -125q14 -7 34.5 -12.5t44.5 -5.5q65 0 65 47q0 16 -11 22.5t-28 6.5q-20 0 -43 -5.5t-37 -10.5l59 79q-26 4 -41.5 20t-15.5 42q0 4 0.5 8t1.5 9l90 424h-71l4 20h72l38 181h20l-38 -181h118l-4 -20h-119l-80 -373q-6 -28 -8.5 -40.5t-2.5 -19.5q0 -25 16 -38t39 -13 q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16l-7 -4.5t-19 -9.5t-28 -9.5t-34 -5.5l-40 -52q11 4 22.5 5t19.5 1q54 0 54 -42q0 -35 -24.5 -52t-66.5 -17q-25 0 -46.5 5.5t-38.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 574,
    d: "M356 690h-258l4 20h536l-4 -20h-258l-147 -690h-20zM308 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 281,
    d: "M119 -5q-31 0 -51 17t-20 46q0 4 0.5 8t1.5 9l90 424h-71l4 20h72l38 181h20l-38 -181h118l-4 -20h-119l-80 -373q-6 -28 -8.5 -40.5t-2.5 -19.5q0 -25 16 -38t39 -13q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16l-8 -5t-21.5 -10t-31 -9.5t-36.5 -4.5zM265 657l76 73h33 l-96 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 616,
    d: "M92 424h229l57 266h-258l4 20h537l-5 -20h-258l-57 -266h230l-4 -20h-230l-85 -404h-20l85 404h-229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 283,
    d: "M40 359h71l30 140h-71l4 20h71l39 181h20l-39 -181h119l-4 -20h-119l-30 -140h119l-4 -20h-120l-47 -223q-4 -18 -6.5 -30.5t-2.5 -20.5q0 -25 16 -37.5t39 -12.5q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16q-1 -1 -9 -5.5t-21 -10t-30.5 -9.5t-36.5 -4q-31 0 -51 17t-20 46 q0 4 0.5 8t1.5 9l56 264h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM533 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM396 663q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19 q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM347 874l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM208 686l4 20h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM474 858q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM332 670q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM424 850q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM488 902q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM286 662q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM350 714q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5 q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM400 833l-13 12l76 73h33zM496 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM257 645l-13 12l76 73h33zM353 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 724,
    d: "M230 -163q-19 5 -28.5 18.5t-9.5 30.5q0 26 19 51t69 59q-56 3 -93.5 22t-60.5 50t-33 71.5t-10 86.5q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355 q-15 -69 -42 -133t-68 -113.5t-98 -80t-132 -32.5q-29 -18 -48 -32.5t-30 -26.5t-15.5 -23t-4.5 -23q0 -30 34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 551,
    d: "M338 -159q-19 5 -28.5 18.5t-9.5 30.5q0 27 21.5 54t77.5 63q-7 7 -7 23q0 1 0.5 5t2.5 14.5t6 30t11 52.5q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37 t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -30 34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 986,
    d: "M101 710h22l137 -685l242 389l-59 290h22l52 -266l167 266h22l-183 -290l79 -389l427 685h22l-444 -710h-22l-77 389l-243 -389h-22zM508 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 723,
    d: "M61 519h21l88 -491q58 63 105 134.5t84 143.5l-38 213h21l32 -182q23 48 41.5 94t32.5 88h20q-17 -54 -39 -108t-49 -108l50 -275q51 55 94 118t78 127.5t61.5 127t44.5 118.5h20q-42 -131 -112.5 -263t-183.5 -256h-18l-49 273q-38 -70 -85.5 -138.5t-107.5 -134.5h-18z M345 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20zM314 844l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5zM199 656l104 74 h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20zM338 841l16 77h20l-16 -77h-20zM449 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 587,
    d: "M-36 20l656 670h-509l5 20h534l-5 -20l-656 -670h510l-4 -20h-535zM375 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 457,
    d: "M-32 20l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396zM276 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 587,
    d: "M-36 20l656 670h-509l5 20h534l-5 -20l-656 -670h510l-4 -20h-535zM399 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 457,
    d: "M-32 20l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396zM298 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 587,
    d: "M-36 20l656 670h-509l5 20h534l-5 -20l-656 -670h510l-4 -20h-535zM322 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 457,
    d: "M-32 20l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396zM221 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 707,
    d: "M281 -10q-56 0 -102 20t-78.5 56t-50.5 86t-18 110q0 49 13 100h603q2 17 3.5 32.5t1.5 32.5q0 58 -16.5 107t-46.5 84.5t-72.5 55.5t-93.5 20q-38 0 -77 -11t-75 -31.5t-67 -49t-52 -63.5l-18 9q21 36 53.5 66.5t72 53t82.5 35t85 12.5q56 0 102 -23t78.5 -63.5 t50 -94.5t17.5 -115q0 -87 -34 -165t-89.5 -136.5t-126.5 -93t-145 -34.5zM281 12q63 0 122 25t108 69.5t83.5 104.5t48.5 129h-580q-8 -38 -8 -74q0 -48 13 -93.5t41 -81t70.5 -57.5t101.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 487,
    d: "M26 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l101 474h-71l4 20h72l17 82q20 95 65.5 147.5t107.5 52.5q27 0 50 -9.5t33 -24.5l-18 -12q-9 12 -27.5 19.5t-40.5 7.5q-54 0 -93 -46.5t-57 -134.5l-17 -82h146l-4 -20h-147 l-101 -474q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1271,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM648 20l656 670h-509l5 20h534 l-5 -20l-656 -670h510l-4 -20h-535zM1006 906l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1141,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM652 20l477 479h-370l4 20h395 l-4 -20l-476 -479h371l-5 -20h-396zM905 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1036,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l70 332h21l-147 -687q-1 -3 -1 -5.5v-4.5q0 -13 12 -13l-4 -20q-6 0 -12 2q-16 6 -16 28v3.5t1.5 10l4.5 22.5t9 42 q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM547 20 l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396zM800 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1010,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM657 -11q-85 0 -137 44l14 16q46 -40 127 -40q60 0 101 23.5t68.5 67t46.5 106.5t36 143l77 360h20l-77 -360q-17 -81 -37.5 -147.5t-51 -113.5t-75.5 -73t-112 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 742,
    d: "M184 710h20l-147 -690h423l-4 -20h-443zM434 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM732 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 414,
    d: "M96 -5q-28 0 -44 16.5t-16 44.5v10t2 11l139 653h20l-139 -653q-1 -5 -1.5 -8.5t-0.5 -7.5q0 -47 52 -47q11 0 26 2.5t28 6.5l3 -16q-14 -5 -34.5 -8.5t-34.5 -3.5zM106 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555 h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM404 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1201,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM848 -11q-85 0 -137 44l14 16q46 -40 127 -40q60 0 101 23.5t68.5 67t46.5 106.5t36 143l77 360h20l-77 -360q-17 -81 -37.5 -147.5t-51 -113.5t-75.5 -73t-112 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 933,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM625 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM923 730h20l-16 -77h-20 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 730,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM422 -170q-28 0 -51 7t-37 27 l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10zM720 730h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 726,
    d: "M232 -163q-19 5 -28.5 18.5t-9.5 30.5q0 27 19 51.5t69 58.5q-56 3 -98.5 28t-72 65t-44.5 91.5t-15 106.5q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -80 -32.5 -155t-86 -134t-123 -96t-143.5 -40q-29 -18 -48 -32.5t-30 -26.5 t-15.5 -23t-4.5 -23q0 -29 34 -37zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 561,
    d: "M156 -168q-19 5 -28.5 18.5t-9.5 30.5q0 26 19 50.5t68 58.5q-40 2 -72 20t-55 47t-35.5 67.5t-12.5 82.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -59 -23.5 -114t-62 -98.5t-88.5 -71.5t-102 -33q-29 -18 -48.5 -32.5 t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -29 34 -37zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1259,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM636 20l656 670h-509l5 20h534 l-5 -20l-656 -670h510l-4 -20h-535z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1141,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM652 20l477 479h-370l4 20h395 l-4 -20l-476 -479h371l-5 -20h-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1036,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l70 332h21l-147 -687q-1 -3 -1 -5.5v-4.5q0 -13 12 -13l-4 -20q-6 0 -12 2q-16 6 -16 28v3.5t1.5 10l4.5 22.5t9 42 q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM547 20 l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 688,
    d: "M571 121q-132 -126 -269 -126q-60 0 -106.5 25.5t-78.5 67t-48.5 95t-16.5 109.5q0 77 32.5 153t86.5 136t125 97t148 37q52 0 90.5 -11.5t65 -32t43 -49t25.5 -62.5l-20 -6q-23 75 -76.5 108t-132.5 33q-76 0 -143 -36.5t-116.5 -94.5t-78.5 -129.5t-29 -141.5 q0 -56 16.5 -106.5t47 -88.5t74 -60.5t96.5 -22.5q66 0 132.5 32t138.5 102l36 169h-158l4 20h178l-72 -338h-20zM457 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    horizAdvX: 576,
    d: "M166 -223q-44 0 -76 9t-54 25.5t-36 39t-22 50.5l20 6q9 -29 25.5 -50t39 -34.5t50 -19.5t57.5 -6q40 0 78.5 11.5t70 34.5t54.5 56.5t33 78.5l28 130q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-58 -8.5q-44 0 -78.5 18.5t-58.5 49t-36.5 70.5t-12.5 83q0 58 24 114.5 t64 101.5t93 72.5t111 27.5q33 0 60 -10t48 -27.5t37.5 -41t28.5 -50.5l26 121h19l-115 -541q-11 -51 -37 -89t-61.5 -63t-77.5 -37t-84 -12zM221 10q35 0 71.5 14.5t68 37.5t55 51t31.5 56l40 187q-5 33 -20 60.5t-37.5 47.5t-51.5 31.5t-60 11.5q-57 0 -106 -27.5 t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM319 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 648,
    d: "M369 740q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -24 -15.5 -42.5t-37.5 -23.5l139 -696h-22l-51 254h-351l-159 -254h-22l436 696q-28 10 -28 44zM489 274l-80 407l-255 -407h335zM433 792q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5 t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9zM470 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM310 662 q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM374 714q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9zM359 780l-13 12 l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 921,
    d: "M511 710h440l-5 -20h-414l-67 -317h363l-5 -20h-363l-70 -333h422l-4 -20h-443l54 254h-266l-212 -254h-25zM424 274l85 404l-340 -404h255zM532 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 884,
    d: "M138 -10q-34 0 -59.5 10.5t-42.5 28.5t-25.5 41.5t-8.5 49.5q0 40 18.5 72.5t51 55.5t76.5 36t94 13q34 0 68.5 -5.5t63.5 -14.5q7 26 18 51t25 48q0 60 -33 95.5t-92 35.5q-39 0 -83.5 -16.5t-92.5 -47.5l-8 16q56 35 101 51.5t87 16.5q58 0 96.5 -31.5t43.5 -92.5 q43 56 102 90t122 34q41 0 76 -15t60.5 -41.5t40 -63t14.5 -79.5q0 -17 -2.5 -40.5t-10.5 -39.5h-450q-3 -23 -3 -42q0 -42 12 -78t34.5 -62.5t54 -41t70.5 -14.5q28 0 57 8t55.5 22.5t49 34.5t37.5 44l18 -5q-16 -27 -40.5 -49.5t-54.5 -39t-62.5 -26t-64.5 -9.5 q-62 0 -106.5 33t-65.5 88q-22 -33 -52.5 -56t-64 -37.5t-66.5 -21t-58 -6.5zM144 10q31 0 67 9.5t68.5 26.5t57.5 40t34 51q-8 30 -8 62q0 27 6 57q-30 11 -63.5 16t-65.5 5q-48 0 -88 -11t-69 -31t-45 -48t-16 -63q0 -22 7 -42.5t22 -36.5t38 -25.5t55 -9.5zM822 268 q7 27 7 57q0 35 -10.5 68t-32 58.5t-54 40.5t-75.5 15q-44 0 -86 -18t-77 -50t-62 -76t-40 -95h430zM470 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 726,
    d: "M680 710l-59 -72q37 -42 56.5 -98.5t19.5 -118.5q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36q-48 0 -87.5 16t-69.5 44l-45 -55h-25l57 69q-38 42 -57 98.5t-19 119.5q0 82 34 159t90 137t127.5 96t147.5 36q48 0 87.5 -17t69.5 -46l47 58h25zM72 290 q0 -60 17.5 -113t52.5 -91l452 549q-29 28 -65.5 44t-81.5 16q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 59 -18 111.5t-52 90.5l-452 -549q29 -27 66 -42t82 -15zM454 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 561,
    d: "M351 645l-13 12l76 73h33zM89 44q-28 30 -43.5 72t-15.5 91q0 63 26 121t68.5 102.5t96 70.5t108.5 26q32 0 60 -11t51 -31l27 34h25l-38 -48q28 -30 43.5 -72t15.5 -91q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5q-33 0 -61 10.5t-51 29.5l-24 -30h-24z M50 209q0 -45 13.5 -83t39.5 -66l323 408q-42 39 -101 39q-50 0 -99.5 -24.5t-88.5 -66t-63 -95.5t-24 -112zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 45 -14 83t-39 66l-324 -407q21 -17 46.5 -27t55.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM444 918h32l46 -73l-19 -12zM348 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM361 730h32 l46 -73l-19 -12zM265 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 647,
    d: "M406 710h18l142 -710h-22l-51 254h-351l-159 -254h-22zM489 274l-80 407l-255 -407h335zM378 841q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 580,
    d: "M216 -10q-43 0 -77.5 18.5t-58.5 49t-36.5 70.5t-12.5 82q0 60 24 117t64.5 101.5t93 71.5t108.5 27q35 0 63.5 -10.5t50 -28t37.5 -41t25 -49.5l26 121h21l-102 -475q-2 -6 -2 -12q0 -12 12 -12l-4 -20q-6 0 -9 1q-19 6 -19 28q0 2 0.5 5t2 10.5l4.5 22.5t8 41 q-21 -26 -47 -47.5t-54.5 -37.5t-58.5 -24.5t-59 -8.5zM218 10q32 0 68.5 13t69.5 35t58 50.5t34 60.5l40 187q-4 30 -18.5 57t-37.5 48t-53.5 33.5t-65.5 12.5q-52 0 -99.5 -26.5t-83.5 -69.5t-57.5 -96t-21.5 -105q0 -40 12.5 -76t35 -63.5t53 -44t66.5 -16.5zM291 653 q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM412 918h32l46 -73l-19 -12zM316 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM342 730h32l46 -73l-19 -12z M246 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM361 841q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM291 653q3 15 11 28.5t19 24.5 t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM222 918h32l46 -73l-19 -12zM126 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM152 730h32l46 -73l-19 -12zM56 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM156 841q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM98 653q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM484 918h32l46 -73l-19 -12zM388 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM371 730h32l46 -73l-19 -12zM275 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM411 841q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5 h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM288 653q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5 h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM424 918h32 l46 -73l-19 -12zM328 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM244 730h32l46 -73l-19 -12zM148 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM360 841 q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM177 657q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5 h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM479 918h32l46 -73l-19 -12zM383 918h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM350 730h32l46 -73l-19 -12zM254 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM408 841q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM275 653q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -10 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5zM189 -167l22 58h-9l13 59h25l-12 -59 l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5zM119 -167l22 58h-9l13 59h25l-12 -59 l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 574,
    d: "M356 690h-258l4 20h536l-4 -20h-258l-147 -690h-20zM168 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 281,
    d: "M119 -5q-31 0 -51 17t-20 46q0 4 0.5 8t1.5 9l90 424h-71l4 20h72l38 181h20l-38 -181h118l-4 -20h-119l-80 -373q-6 -28 -8.5 -40.5t-2.5 -19.5q0 -25 16 -38t39 -13q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16l-8 -5t-21.5 -10t-31 -9.5t-36.5 -4.5zM69 -167l22 58h-9 l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 182,
    d: "M-126 -170q-28 0 -51 7t-37 27l18 12q14 -16 33.5 -21t39.5 -5q19 0 40.5 9t40 24t32.5 36t19 45l118 555h20l-118 -555q-6 -29 -23 -53.5t-39 -42.5t-46.5 -28t-46.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 548,
    d: "M203 -10q-42 0 -76.5 15.5t-59 43t-38 65t-13.5 81.5q0 17 1.5 37t7.5 37h451q3 21 3 42q0 42 -12.5 78t-35 62.5t-54 41t-69.5 14.5q-29 0 -58 -8t-55.5 -22.5t-49 -34.5t-37.5 -44l-17 5q15 27 39.5 49.5t54.5 39t63 26t65 9.5q42 0 76 -17t58.5 -47t38 -70.5 t13.5 -86.5q0 -63 -25.5 -120.5t-67 -101t-94.5 -69t-109 -25.5zM207 10q43 0 85 18t77.5 50t62 76t39.5 95h-429q-4 -23 -4 -48q0 -43 12 -78t34 -60t53 -39t70 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 539,
    d: "M412 730l-96 -85l-13 12l49 47l8 26h52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 288,
    d: "M48 656l104 74h16l73 -74l-18 -12l-68 63l-94 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 288,
    d: "M48 718l18 12l68 -63l94 63l13 -12l-104 -74h-16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 361,
    d: "M50 706h266l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 236,
    d: "M106 670q20 0 39 17.5t27 42.5h18q-3 -15 -12 -29t-21 -24.5t-26 -17t-28 -6.5q-25 0 -41 18t-16 44q0 5 2 15h19q-1 -4 -1 -11q0 -20 11.5 -34.5t28.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 114,
    d: "M39 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 226,
    d: "M58 662q0 14 5.5 26.5t15 21.5t22 14.5t25.5 5.5q20 0 31.5 -13t11.5 -33q0 -14 -5.5 -26.5t-15 -21.5t-22 -14.5t-25.5 -5.5q-20 0 -31.5 13t-11.5 33zM122 714q-18 0 -33 -13.5t-15 -35.5q0 -14 8.5 -23.5t22.5 -9.5q16 0 32.5 14t16.5 35q0 15 -9 24t-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 193,
    d: "M61 -159q-19 5 -28.5 18.5t-9.5 30.5q0 29 24 56.5t86 67.5l9 -14q-29 -18 -48.5 -32.5t-30.5 -26.5t-15.5 -23t-4.5 -23q0 -30 34 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 364,
    d: "M231 663q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 284,
    d: "M53 645l-13 12l76 73h33zM149 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 284,
    d: "M151 730h32l46 -73l-19 -12zM55 730h33l45 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 236,
    d: "M46 653q3 15 11 28.5t19 24.5t25.5 17.5t30.5 6.5q29 0 43 -19t14 -43q0 -12 -1 -15h-18q0 3 0.5 6t0.5 6q0 48 -40 48q-26 0 -43.5 -18.5t-22.5 -41.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 616,
    d: "M-24 20l291 690h18l290 -690v-20h-599v20zM553 20l-277 661l-278 -661h555z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 819,
    d: "M63 21h219q-50 22 -90 58t-67.5 81t-42 97.5t-14.5 107.5q0 69 25 132.5t69 111.5t104.5 77t132.5 29t132.5 -29t104.5 -77t69 -111.5t25 -132.5q0 -55 -14.5 -107.5t-42 -97.5t-67.5 -81t-90 -58h219v-21h-289v21q64 13 113.5 48t82.5 83t50 103.5t17 109.5 q0 61 -21.5 120t-61.5 105t-97.5 74.5t-129.5 28.5t-129.5 -28.5t-97.5 -74.5t-61.5 -105t-21.5 -120q0 -54 17 -109.5t50 -103.5t82 -83t114 -48v-21h-289v21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 557,
    d: "M127 519h21l-62 -291q-12 -56 -12 -97q0 -121 104 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h21l-102 -479q-1 -1 -1 -7q0 -13 12 -13l-5 -20q-27 0 -27 30q0 8 1 10l20 92q-23 -33 -52 -59t-61 -44.5t-65.5 -28.5t-66.5 -10q-103 0 -117 104l-65 -306h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 622,
    d: "M479 -5q-35 0 -57 22.5t-22 59.5v422h-246v-499h-20v499h-80v20h476v-20h-110v-422q0 -29 18 -46t48 -17q11 0 26.5 2.5t28.5 6.5l7 -16q-14 -5 -34.5 -8.5t-34.5 -3.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 684,
    d: "M184 710h217q65 0 112.5 -21t78.5 -57.5t46 -85.5t15 -106q0 -95 -30 -175.5t-84 -139t-128 -92t-161 -33.5h-217zM254 20q89 0 159.5 34t119 91.5t74.5 132.5t26 157q0 56 -15 103t-44.5 80.5t-74 52.5t-102.5 19h-197l-143 -670h197zM224 -127l16 77h20l-16 -77h-20z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 579,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 62 -10.5t49.5 -28t37.5 -41t25 -49.5l70 332h21l-147 -687q-1 -3 -1 -5.5v-4.5q0 -13 12 -13l-4 -20q-6 0 -12 2q-16 6 -16 28v3.5t1.5 10l4.5 22.5t9 42 q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5t34.5 61l40 187q-4 31 -19.5 58.5t-39 48t-52 32.5t-58.5 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5zM185 -127 l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 701,
    d: "M184 710h20l-72 -337h467l72 337h20l-151 -710h-20l75 353h-467l-75 -353h-20zM250 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 540,
    d: "M172 730h20l-73 -345q22 32 50 58.5t59 45t63.5 28.5t64.5 10q118 0 118 -139q0 -44 -12 -99l-61 -289h-20l61 289q5 27 8.5 51t3.5 44q0 123 -102 123q-35 0 -70.5 -14t-68.5 -38t-60.5 -56.5t-45.5 -70.5l-70 -328h-20zM184 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 743,
    d: "M184 710h15l370 -681l144 680h20l-151 -709h-22l-364 671l-143 -671h-20zM487 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 540,
    d: "M127 519h20l-28 -134q22 31 51 57.5t61.5 45t67 29t67.5 10.5q56 0 83 -30.5t27 -95.5q0 -24 -3.5 -52t-10.5 -60l-61 -289h-20l61 289q13 61 13 107q0 57 -22.5 84t-70.5 27q-35 0 -72.5 -13.5t-72 -37.5t-63.5 -57t-47 -71l-70 -328h-20zM345 653l16 77h20l-16 -77h-20 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 616,
    d: "M33 0l151 710h275q35 0 63 -15t47 -40t29 -56.5t10 -65.5q0 -46 -18 -90t-48 -79.5t-70.5 -58.5t-85.5 -26l111 -279h-24l-111 279h-250l-59 -279h-20zM378 299q44 0 82 21t66.5 54t45 74t16.5 82q0 32 -9.5 61t-27 51t-42.5 35t-55 13h-254l-83 -391h261zM213 -127 l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 317,
    d: "M127 519h20l-28 -134q41 61 94 94.5t107 38.5q5 1 9.5 1h9.5l-4 -20q-71 -3 -131.5 -48t-96.5 -123l-70 -328h-20zM-10 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 579,
    d: "M238 -5q-81 0 -139 26.5t-100 83.5l17 13q40 -56 94.5 -81t132.5 -25q58 0 105 12.5t80 36.5t51 59.5t18 82.5q0 30 -12 52.5t-36 39t-60 28.5t-84 23q-47 10 -84 21t-62.5 27t-39 39.5t-13.5 57.5q0 52 20.5 93.5t58 70.5t89 44.5t113.5 15.5q65 0 109 -19.5t74 -65.5 l-16 -14q-30 47 -69.5 63.5t-99.5 16.5q-69 0 -118 -15.5t-80 -43t-45.5 -64t-14.5 -78.5q0 -29 11 -49t33.5 -34.5t57 -25.5t80.5 -21q47 -11 85.5 -23t66 -29.5t42.5 -43t15 -61.5q0 -50 -20 -89.5t-56.5 -67t-88.5 -42t-115 -14.5zM202 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 450,
    d: "M159 -10q-57 0 -100 20.5t-71 63.5l17 13q30 -39 67.5 -58t90.5 -19q41 0 76 10.5t61 29t41 45.5t15 60q0 22 -10 37.5t-29 26.5t-46.5 20t-62.5 18q-33 8 -58 16t-42.5 18.5t-26.5 26t-9 38.5q0 43 17.5 75.5t47 53.5t67 31.5t77.5 10.5q60 0 97.5 -21.5t47.5 -53.5 l-19 -8q-11 31 -49 47t-85 16q-35 0 -67.5 -8.5t-57.5 -26.5t-40 -45.5t-15 -64.5q0 -19 7.5 -32t22.5 -22t37.5 -16t52.5 -15q37 -10 67.5 -19t52 -22t33 -30.5t11.5 -43.5q0 -38 -16.5 -69.5t-45.5 -54.5t-69 -35.5t-87 -12.5zM132 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 574,
    d: "M356 690h-258l4 20h536l-4 -20h-258l-147 -690h-20zM183 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 281,
    d: "M119 -5q-31 0 -51 17t-20 46q0 4 0.5 8t1.5 9l90 424h-71l4 20h72l38 181h20l-38 -181h118l-4 -20h-119l-80 -373q-6 -28 -8.5 -40.5t-2.5 -19.5q0 -25 16 -38t39 -13q16 0 31 3.5t26.5 8t19 8.5t8.5 5l7 -16l-8 -5t-21.5 -10t-31 -9.5t-36.5 -4.5zM77 -127l16 77h20 l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 986,
    d: "M101 710h22l137 -685l242 389l-59 290h22l52 -266l167 266h22l-183 -290l79 -389l427 685h22l-444 -710h-22l-77 389l-243 -389h-22zM567 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 723,
    d: "M61 519h21l88 -491q58 63 105 134.5t84 143.5l-38 213h21l32 -182q23 48 41.5 94t32.5 88h20q-17 -54 -39 -108t-49 -108l50 -275q51 55 94 118t78 127.5t61.5 127t44.5 118.5h20q-42 -131 -112.5 -263t-183.5 -256h-18l-49 273q-38 -70 -85.5 -138.5t-107.5 -134.5h-18z M396 730h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 986,
    d: "M101 710h22l137 -685l242 389l-59 290h22l52 -266l167 266h22l-183 -290l79 -389l427 685h22l-444 -710h-22l-77 389l-243 -389h-22zM587 833l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 723,
    d: "M61 519h21l88 -491q58 63 105 134.5t84 143.5l-38 213h21l32 -182q23 48 41.5 94t32.5 88h20q-17 -54 -39 -108t-49 -108l50 -275q51 55 94 118t78 127.5t61.5 127t44.5 118.5h20q-42 -131 -112.5 -263t-183.5 -256h-18l-49 273q-38 -70 -85.5 -138.5t-107.5 -134.5h-18z M416 645l-13 12l76 73h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 986,
    d: "M101 710h22l137 -685l242 389l-59 290h22l52 -266l167 266h22l-183 -290l79 -389l427 685h22l-444 -710h-22l-77 389l-243 -389h-22zM533 841l16 77h20l-16 -77h-20zM644 841l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 723,
    d: "M61 519h21l88 -491q58 63 105 134.5t84 143.5l-38 213h21l32 -182q23 48 41.5 94t32.5 88h20q-17 -54 -39 -108t-49 -108l50 -275q51 55 94 118t78 127.5t61.5 127t44.5 118.5h20q-42 -131 -112.5 -263t-183.5 -256h-18l-49 273q-38 -70 -85.5 -138.5t-107.5 -134.5h-18z M363 653l16 77h20l-16 -77h-20zM474 653l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 587,
    d: "M-36 20l656 670h-509l5 20h534l-5 -20l-656 -670h510l-4 -20h-535zM194 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 457,
    d: "M-32 20l477 479h-370l4 20h395l-4 -20l-476 -479h371l-5 -20h-396zM131 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM216 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM181 -127l16 77h20l-16 -77h-20z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    d: "M184 710h434l-4 -20h-414l-68 -317h363l-4 -20h-363l-71 -333h423l-4 -20h-443zM478 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5 t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 521,
    d: "M220 -10q-45 0 -80 17.5t-59 47.5t-37 70t-13 85q0 59 23 116t63.5 101.5t95.5 72t120 27.5q25 0 52.5 -9t49.5 -26t36.5 -42.5t14.5 -59.5q0 -142 -262 -142q-38 0 -78 1t-91 4q-3 -21 -3 -42q0 -41 11 -77.5t33 -64t55 -43.5t76 -16q27 0 56 8.5t56 23.5t49.5 37 t37.5 49l19 -6q-17 -30 -41.5 -54.5t-54 -41.5t-62.5 -26.5t-67 -9.5zM329 507q-49 0 -93 -19.5t-79.5 -52t-61 -75t-36.5 -87.5q51 -3 90.5 -4t77.5 -1q66 0 111.5 9t73.5 25.5t40.5 39t12.5 49.5q0 30 -13 52t-33 36.5t-44 21t-46 6.5zM415 663q-21 0 -35.5 6t-26.5 13 t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 214,
    d: "M184 709h20l-151 -709h-20zM6 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 182,
    d: "M127 519h20l-110 -519h-20zM172 730h20l-16 -77h-20zM-10 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 726,
    d: "M298 -5q-59 0 -105 24t-77.5 64.5t-47.5 93.5t-16 110q0 82 34 159t90 137t127.5 96t147.5 36q59 0 105 -25t77.5 -66t47.5 -94t16 -109q0 -81 -34 -158t-90 -136.5t-127.5 -95.5t-147.5 -36zM303 15q75 0 143 36t119 94t81.5 130t30.5 144q0 55 -16 105t-46 88 t-72.5 60.5t-95.5 22.5q-75 0 -143 -36t-119.5 -94t-82 -130t-30.5 -145q0 -55 15.5 -105t45.5 -87.5t73 -60t97 -22.5zM262 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 561,
    d: "M215 -10q-42 0 -76 17t-58.5 46.5t-37.5 69t-13 84.5q0 63 26 121t68.5 102.5t96 70.5t108.5 26q41 0 75 -17t58 -47t37.5 -70t13.5 -85q0 -62 -26 -119.5t-68 -101.5t-95.5 -70.5t-108.5 -26.5zM218 10q50 0 99.5 24.5t88.5 65t63 94t24 111.5q0 42 -12.5 78.5t-34.5 64 t-53 43.5t-68 16q-50 0 -99 -24.5t-88 -66t-63.5 -95.5t-24.5 -112q0 -41 12 -77.5t34.5 -63.5t53 -42.5t68.5 -15.5zM179 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 724,
    d: "M298 -5q-61 0 -102 18t-66 49.5t-36 73.5t-11 90q0 31 4 63.5t11 65.5l75 355h20l-75 -355q-7 -32 -11 -64t-4 -62q0 -45 10 -84t33 -68t61 -45.5t94 -16.5q76 0 132 30t95.5 78t64 109t37.5 123l75 355h20l-75 -355q-15 -71 -43 -136t-70.5 -114.5t-101.5 -79.5 t-137 -30zM262 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 551,
    d: "M167 -10q-120 0 -120 139q0 43 12 99l62 291h20l-62 -291q-12 -56 -12 -97q0 -121 105 -121q36 0 72.5 13.5t70 37t62 56.5t47.5 72l70 330h20l-96 -452q-2 -11 -4.5 -21t-2.5 -12q0 -14 13 -14l-5 -20q-6 0 -12 2q-15 6 -15 27q0 1 0.5 4t2 13t5.5 30t12 56 q-23 -33 -51.5 -59t-60.5 -44.5t-66 -28.5t-67 -10zM164 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20zM352 918h32l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5zM246 730h32 l46 -73l-18 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 594,
    d: "M277 277l-180 433h23l172 -412l348 412h23l-366 -435l-59 -275h-20zM449 851q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16 t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 460,
    d: "M-37 -207q30 6 51.5 16t39.5 26.5t35.5 41.5t40.5 60l41 63l-119 519h22l112 -494l58 92q47 75 79.5 130t55 100.5t38 86t28.5 85.5h21q-14 -48 -29 -89.5t-38 -87.5t-56.5 -103t-83.5 -136l-82 -129q-36 -56 -61.5 -92.5t-49 -58t-47 -32t-54.5 -15.5zM350 663 q-21 0 -35.5 6t-26.5 13t-23 13t-26 6t-26 -6.5t-18 -15t-10.5 -16.5t-4.5 -10h-19q0 2 4.5 13t14 23t25.5 21.5t40 9.5q18 0 31 -6t24.5 -13t24.5 -13t31 -6q19 0 32 7t20.5 15.5t10.5 16t3 9.5h19q-1 -3 -5.5 -14t-15 -23t-27.5 -21t-43 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 535
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 861
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 519,
    d: "M59 261l4 20h384l-4 -20h-384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 838,
    d: "M59 261l4 20h703l-4 -20h-703z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 162,
    d: "M183 730l-28 -86h9l-15 -74h-26l16 74l31 86h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 159,
    d: "M124 570l28 86h-9l15 74h26l-16 -74l-31 -86h-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 257,
    d: "M33 -76l26 76h-9l16 74h25l-16 -74l-28 -76h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 238,
    d: "M183 730l-28 -86h9l-15 -74h-26l16 74l31 86h13zM259 730l-28 -86h9l-15 -74h-26l16 74l31 86h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 235,
    d: "M124 570l28 86h-9l15 74h26l-16 -74l-31 -86h-13zM200 570l28 86h-9l15 74h26l-16 -74l-31 -86h-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 325,
    d: "M33 -76l26 76h-9l16 74h25l-16 -74l-28 -76h-14zM101 -76l25 76h-9l16 74h26l-16 -74l-29 -76h-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 358,
    d: "M78 -130l83 391h-125l4 20h126l105 494h20l-105 -494h124l-4 -20h-125l-83 -391h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 366,
    d: "M82 -130l70 331h-125l4 20h126l23 110h-125l4 20h125l90 424h20l-90 -424h125l-5 -20h-124l-23 -110h124l-4 -20h-125l-70 -331h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 331,
    d: "M250 357q0 -19 -8 -36t-20.5 -29.5t-29.5 -20t-35 -7.5q-26 0 -43 18.5t-17 46.5q0 18 8 35t21.5 29.5t30.5 20t34 7.5q27 0 43 -19t16 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 342,
    d: "M8 0l14 64h19l-13 -64h-20zM99 0l14 64h19l-13 -64h-20zM190 0l14 64h20l-14 -64h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 950,
    d: "M218 444q-49 0 -78 32t-29 80q0 33 14 62.5t37 52t52 36t59 13.5q49 0 78 -32t29 -80q0 -33 -14 -63t-37 -52.5t-52 -35.5t-59 -13zM222 464q26 0 50.5 11.5t44 31t31.5 45t12 52.5q0 41 -26 68.5t-66 27.5q-26 0 -50.5 -12t-43.5 -31.5t-31 -45t-12 -52.5 q0 -40 25 -67.5t66 -27.5zM406 -10q-49 0 -78 32t-29 80q0 33 14 62.5t37 52t52 36t59 13.5q49 0 78 -32.5t29 -80.5q0 -33 -14 -62.5t-37 -52t-52 -35.5t-59 -13zM410 10q26 0 50.5 11.5t44 31t31.5 45t12 52.5q0 40 -25 68t-66 28q-26 0 -50.5 -12t-44 -31.5t-31.5 -45 t-12 -52.5q0 -40 24.5 -67.5t66.5 -27.5zM721 -10q-48 0 -77.5 32t-29.5 80q0 33 14 62.5t37 52t52 36t59 13.5q49 0 78 -32.5t29 -80.5q0 -33 -14 -62.5t-37 -52t-52 -35.5t-59 -13zM725 10q26 0 50.5 11.5t44 31t31.5 44.5t12 52q0 41 -25.5 69t-66.5 28q-26 0 -50.5 -12 t-43.5 -31.5t-31 -45t-12 -52.5q0 -40 24.5 -67.5t66.5 -27.5zM-7 11l679 700l13 -12l-679 -700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 334,
    d: "M36 268l261 169l-5 -22l-239 -156l173 -157l-5 -22l-189 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 334,
    d: "M281 250l-262 -170l5 22l240 157l-174 156l5 22l189 -169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 120,
    d: "M-275 11l679 700l13 -12l-679 -700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 420,
    d: "M236 422q-35 0 -60 14t-41 36.5t-23.5 51t-7.5 56.5q0 39 17 80t46 74.5t68 54.5t83 21q34 0 59 -14.5t41 -37t23.5 -50.5t7.5 -56q0 -40 -16.5 -81t-45.5 -74t-67.5 -54t-83.5 -21zM124 582q0 -26 7 -51.5t21.5 -45.5t36 -32t51.5 -12q42 0 77 20.5t59.5 52t38.5 67.5 t14 68q0 26 -7 51.5t-21.5 45.5t-36 32.5t-50.5 12.5q-42 0 -77 -20.5t-60 -52t-39 -68t-14 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 353,
    d: "M275 427l23 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM108 556h194l47 219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 351,
    d: "M252 668q51 0 82.5 -27.5t31.5 -72.5q0 -32 -14.5 -59t-38.5 -46.5t-54.5 -30t-62.5 -10.5q-45 0 -75.5 21t-40.5 56l18 6q10 -29 37 -47t66 -18q29 0 55 9.5t46 26t32 39t12 48.5q0 21 -8.5 37t-22.5 27t-32 16.5t-38 5.5q-32 0 -62.5 -13t-53.5 -36h-20q3 8 11 26 t18 41t21 47t20 45t14.5 35t6.5 16h200l-4 -19h-184l-71 -162q24 20 53 29.5t58 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 379,
    d: "M398 571q0 -31 -14.5 -58.5t-39 -48.5t-56.5 -33t-66 -12q-54 0 -87 32t-33 89q0 55 15 104t42.5 86t65 58.5t82.5 21.5q42 0 71 -20.5t35 -55.5l-17 -10q-5 30 -30 49t-62 19q-59 0 -106 -50.5t-67 -144.5q22 38 63.5 60.5t86.5 22.5q52 0 84.5 -31.5t32.5 -77.5z M227 437q29 0 56.5 10.5t48.5 28t34 41t13 49.5q0 40 -29.5 68.5t-75.5 28.5q-29 0 -56.5 -10.5t-48.5 -28.5t-34 -41.5t-13 -49.5q0 -40 29.5 -68t75.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 312,
    d: "M373 791h-245l4 19h276l-296 -383h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 367,
    d: "M376 546q0 -28 -14.5 -50.5t-38 -38.5t-54 -25t-61.5 -9q-57 0 -88 28t-31 66q0 22 10.5 41t27.5 34t38 25t41 16q-26 9 -44 27.5t-18 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15 q32 -10 53 -32.5t21 -54.5zM356 544q0 19 -9 33.5t-24 25t-33.5 16t-37.5 5.5q-24 0 -49.5 -7.5t-46.5 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5q24 0 49 7t46 20.5t34 32.5t13 43zM164 706q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5q20 0 42 6 t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 379,
    d: "M114 658q0 31 14.5 58.5t39 48.5t56.5 33t66 12q54 0 87 -32t33 -89q0 -55 -15 -104t-42 -86t-64.5 -58.5t-83.5 -21.5q-42 0 -71 20.5t-35 55.5l17 10q5 -31 30 -49.5t63 -18.5q58 0 105 50.5t67 143.5q-22 -37 -63.5 -60t-86.5 -23q-52 0 -84.5 32t-32.5 78zM285 792 q-29 0 -56 -10.5t-48 -28t-34 -41t-13 -49.5q0 -41 29 -69t75 -28q29 0 56.5 10.5t48.5 28.5t34 41.5t13 49.5q0 19 -8 36.5t-22 31t-33 21t-42 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 421,
    d: "M129 -85q-35 0 -60 14t-41 36.5t-23.5 51t-7.5 56.5q0 39 17 80t46 74.5t68 54.5t83 21q34 0 59 -14.5t41 -37t23.5 -50.5t7.5 -56q0 -40 -16.5 -81t-45.5 -74t-67.5 -54t-83.5 -21zM17 75q0 -26 7 -51.5t21.5 -45.5t36 -32t51.5 -12q42 0 77 20.5t59.5 52t38.5 67.5 t14 68q0 26 -7 51.5t-21.5 45.5t-36 32.5t-50.5 12.5q-42 0 -77 -20.5t-60 -52t-39 -68t-14 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 240,
    d: "M144 -61l-4 -19h-173l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33.5 18t26 18.5t11.5 9.5h19l-78 -370h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 354,
    d: "M-40 -80q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5t-69 22.5q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12.5 12.5t31.5 22.5t47.5 22t62.5 10q56 0 80.5 -26.5t24.5 -62.5t-17 -59.5t-42.5 -38.5t-54 -24 t-52.5 -17q-40 -14 -65.5 -32t-40.5 -37t-21.5 -38t-9.5 -34h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 363,
    d: "M98 -85q-19 0 -40.5 4t-39.5 14.5t-29.5 29.5t-11.5 48l17 7q0 -39 28.5 -61.5t79.5 -22.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33.5 55t-90.5 20h-21l4 18h21q70 0 108.5 23t38.5 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48 t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 352,
    d: "M167 -80l23 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM0 49h194l47 219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 350,
    d: "M144 161q51 0 82.5 -27.5t31.5 -72.5q0 -32 -14.5 -59t-38.5 -46.5t-54.5 -30t-62.5 -10.5q-45 0 -75.5 21t-40.5 56l18 6q10 -29 37 -47t66 -18q29 0 55 9.5t46 26t32 39t12 48.5q0 21 -8.5 37t-22.5 27t-32 16.5t-38 5.5q-32 0 -62.5 -13t-53.5 -36h-20q4 8 11.5 26 t17.5 41t21 47t20 45t14.5 35t6.5 16h200l-4 -19h-184l-71 -162q24 20 53 29.5t58 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 379,
    d: "M291 67q0 -31 -14.5 -58.5t-39 -48.5t-56.5 -33t-66 -12q-54 0 -87 32t-33 89q0 55 15 104t42.5 86t65 58.5t82.5 21.5q42 0 71 -20.5t35 -55.5l-17 -10q-5 30 -30 49t-62 19q-59 0 -106 -50.5t-67 -144.5q22 38 63.5 60.5t86.5 22.5q52 0 84.5 -31.5t32.5 -77.5z M120 -67q29 0 56.5 10.5t48.5 28t34 41t13 49.5q0 40 -29.5 68.5t-75.5 28.5q-29 0 -56.5 -10.5t-48.5 -28.5t-34 -41.5t-13 -49.5q0 -40 29.5 -68t75.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 313,
    d: "M265 284h-245l4 19h276l-296 -383h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 366,
    d: "M267 39q0 -28 -14.5 -50.5t-37.5 -38.5t-53.5 -25t-61.5 -9q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5 t-37 -15q33 -10 53.5 -32.5t20.5 -54.5zM248 37q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5q24 0 49 7t46 20.5t34 32.5t13 43zM56 199q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5 q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 380,
    d: "M7 154q0 31 15 58.5t39.5 48.5t56.5 33t66 12q54 0 87 -32t33 -89q0 -55 -15 -104t-42 -86t-64.5 -58.5t-83.5 -21.5q-43 0 -71.5 20.5t-34.5 55.5l17 10q5 -31 30 -49.5t62 -18.5q59 0 106 50.5t67 143.5q-22 -37 -63.5 -60t-86.5 -23q-53 0 -85.5 32t-32.5 78zM179 288 q-29 0 -56 -10.5t-48 -28t-34 -41t-13 -49.5q0 -20 8 -38t21.5 -31t32.5 -20.5t42 -7.5q29 0 56.5 10.5t48.5 28.5t34 41.5t13 49.5q0 19 -8 36.5t-22 31t-33 21t-42 7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 514,
    d: "M159 0q-30 10 -53.5 30t-40.5 48t-26 61.5t-9 70.5q0 56 19 107t52 92t76.5 69.5t92.5 40.5l27 126h19l-26 -122q9 2 19.5 3t21.5 1q7 0 13 -0.5t12 -1.5l26 120h20l-26 -123q45 -10 75 -38t41 -73l-22 -7q-14 48 -53 75.5t-93 27.5q-52 0 -101.5 -23.5t-87.5 -63.5 t-61.5 -93.5t-23.5 -112.5q0 -42 12.5 -79.5t34.5 -65t53 -43.5t69 -16q29 0 59.5 9t57.5 24t48.5 35t31.5 41l19 -6q-12 -22 -30 -41t-40.5 -34.5t-48 -26.5t-52.5 -16l-25 -115h-19l23 112q-6 -1 -12.5 -1.5t-12.5 -0.5q-11 0 -20.5 1.5t-19.5 3.5l-25 -115h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 595,
    d: "M54 0l32 151h-89l4 20h89l115 539h434l-4 -20h-414l-67 -316h353l-4 -20h-354l-39 -183h160l-4 -20h-160l-32 -151h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 438,
    d: "M59 366h103q-11 41 -24.5 77.5t-13.5 76.5q0 39 17 74.5t44 62t62 42.5t71 16q48 0 83 -28.5t49 -76.5l-19 -12q-14 45 -45.5 71t-73.5 26q-31 0 -60.5 -13.5t-53 -37t-38 -54.5t-14.5 -65q0 -40 14 -78t25 -81h166l-5 -20h-157q3 -14 5 -29.5t2 -35.5h155l-4 -20h-152 q-2 -26 -9 -50.5t-25 -52t-49.5 -61.5t-80.5 -79q16 3 34 5t35 2q22 0 39 -3t32.5 -7t31 -7t33.5 -3q20 0 43 5t55 16l2 -19q-56 -22 -105 -22q-21 0 -38 3t-33 7t-33 7t-38 3q-20 0 -45.5 -3.5t-46.5 -8.5l-6 17q56 51 91 86t55 62t27.5 51t9.5 52h-97l4 20h94q0 18 -2 34 t-6 31h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 780,
    d: "M758 376h-78l-15 -70h78l-4 -20h-78l-60 -286h-23l-155 286h-291l-61 -286h-20l61 286h-77l4 20h77l15 70h-77l4 20h77l67 314h15l170 -314h277l67 313h20l-67 -313h78zM155 396h208l-149 275zM587 29l54 257h-194zM136 306h276l-38 70h-223zM436 306h209l15 70h-262z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1020,
    d: "M55 369h132l-14 70h-103l4 20h95l-50 251h22l50 -251h320l-50 245h22l52 -266l166 266h22l-154 -245h321l157 251h22l-157 -251h95l-5 -20h-103l-43 -70h131l-4 -20h-140l-218 -349h-22l-77 389l-243 -389h-22l-70 349h-140zM619 25l202 324h-267zM277 25l202 324h-266z M550 369h284l43 70h-321l-15 -25zM515 439h-320l14 -70h283l28 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 776,
    d: "M162 401q18 60 54 116.5t86 100t112.5 70t133.5 26.5q45 0 81 -11.5t62.5 -32t44 -49t25.5 -62.5l-20 -6q-11 39 -32 66t-47.5 43.5t-58 24t-63.5 7.5q-66 0 -123.5 -24.5t-104 -65t-80 -93.5t-50.5 -110h377l-14 -20h-368q-5 -18 -7.5 -35.5t-3.5 -34.5h336l-14 -20 h-322q0 -56 16.5 -106.5t47 -88.5t73 -60t95.5 -22q33 0 70 9t73.5 27t71 46.5t62.5 67.5l17 -5q-26 -40 -62 -71t-76.5 -52t-82.5 -31.5t-81 -10.5q-58 0 -103.5 25t-76.5 66t-47.5 95t-16.5 111h-116l14 20h102q1 17 3.5 34.5t7.5 35.5h-70l14 20h61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 394,
    d: "M414 600h-87q11 -33 11 -67q0 -46 -18 -90t-48.5 -79.5t-71 -58.5t-85.5 -26l112 -279h-24l-120 299h25q44 0 82 21t66.5 54t44.5 74t16 82q0 19 -3.5 36t-9.5 34h-200l4 20h187q-16 30 -43 50t-62 20h-67l4 20h310l-4 -20h-173q40 -24 60 -70h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 309,
    d: "M160 -5q-38 0 -59.5 22.5t-21.5 69.5v523q0 28 6 51.5t16 41t24 27.5t31 10q34 0 55 -36t21 -94q0 -39 -11 -81t-29.5 -82.5t-42.5 -78t-50 -65.5v-227q0 -29 18 -46t49 -17q13 0 28.5 4.5t30.5 10.5l7 -16q-17 -8 -35.5 -12.5t-36.5 -4.5zM211 604q0 56 -14 86t-40 30 t-42 -30.5t-16 -79.5v-280q22 27 42.5 62.5t36 73t24.5 73.5t9 65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1054,
    d: "M196 671l-143 -671h-20l151 710h15l370 -681l144 680h20l-151 -709h-22zM872 357q-30 0 -55 11.5t-42 31.5t-26.5 46.5t-9.5 56.5q0 42 17.5 80t47 67.5t67 47t77.5 17.5q30 0 55 -11.5t42.5 -31.5t27 -47t9.5 -57q0 -41 -17.5 -79.5t-47 -67.5t-67.5 -46.5t-78 -17.5z M761 505q0 -27 8.5 -50.5t23.5 -41t36 -27.5t47 -10q34 0 67 15.5t59 41.5t42 60t16 72q0 27 -8.5 51t-23.5 41.5t-36.5 27.5t-47.5 10q-34 0 -66.5 -15.5t-58.5 -41.5t-42 -60.5t-16 -72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 630,
    d: "M622 710h22l-59 -277h-19l51 239l-135 -197h-17l-51 197l-50 -239h-20l59 277h21l55 -209zM301 664q-9 18 -23 24.5t-34 6.5q-47 0 -67.5 -18.5t-20.5 -47.5q0 -11 6.5 -18.5t17 -12.5t24 -9.5t27.5 -8.5q26 -8 47.5 -21.5t21.5 -41.5q0 -42 -30.5 -64.5t-81.5 -22.5 q-62 0 -94 44l14 17q15 -23 35 -32.5t50 -9.5q39 0 63 15.5t24 47.5q0 22 -19 32t-43 18q-15 4 -29.5 9t-26 12t-19 17t-7.5 25q0 42 31 66t81 24q25 0 42.5 -7.5t29.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 621,
    d: "M338 692h-90l-55 -259h-20l55 259h-90l4 20h200zM386 710h21l54 -209l144 209h22l-59 -277h-19l50 239l-134 -197h-17l-51 197l-51 -239h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 819,
    d: "M63 21h219q-50 22 -90 58t-67.5 81t-42 97.5t-14.5 107.5q0 69 25 132.5t69 111.5t104.5 77t132.5 29t132.5 -29t104.5 -77t69 -111.5t25 -132.5q0 -55 -14.5 -107.5t-42 -97.5t-67.5 -81t-90 -58h219v-21h-289v21q64 13 113.5 48t82.5 83t50 103.5t17 109.5 q0 61 -21.5 120t-61.5 105t-97.5 74.5t-129.5 28.5t-129.5 -28.5t-97.5 -74.5t-61.5 -105t-21.5 -120q0 -54 17 -109.5t50 -103.5t82 -83t114 -48v-21h-289v21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 618,
    d: "M306 10q69 0 121 22t81 56l13 -15q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-455v-150q33 -44 82.5 -69.5t108.5 -25.5zM306 511q-59 0 -108.5 -26t-82.5 -71 v-139h384v138q-34 45 -85 71.5t-108 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 752,
    d: "M11 11l679 700l13 -12l-679 -700zM244 361l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74zM509 -5q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5 t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33 55t-91 20h-21l4 18h21q69 0 108 23t39 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5 q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 769,
    d: "M63 11l679 700l13 -12l-679 -700zM522 -5q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33 55t-91 20h-21l4 18h21q69 0 108 23t39 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43 l-12 12q20 30 58.5 48t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9zM54 343q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5t-69 22.5 q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12.5 12.5t31.5 22.5t47.5 22t62.5 10q56 0 80.5 -26.5t24.5 -62.5t-17 -59.5t-42.5 -38.5t-54 -24t-52.5 -17q-40 -14 -65.5 -32t-40.5 -37t-21.5 -38t-9.5 -34h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 752,
    d: "M21 11l679 700l13 -12l-679 -700zM242 361l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74zM507 -4q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5 t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5t-37 -15q33 -10 53.5 -32.5t20.5 -54.5q0 -28 -14.5 -50.5t-37.5 -38.5t-53.5 -25t-61.5 -9zM513 14q24 0 49 7t46 20.5t34 32.5t13 43 q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5zM554 214q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35q0 -15 8 -27.5t21 -20.5t29 -12.5 t33 -4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 757,
    d: "M42 11l679 700l13 -12l-679 -700zM510 -4q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5t-37 -15 q33 -10 53.5 -32.5t20.5 -54.5q0 -28 -14.5 -50.5t-37.5 -38.5t-53.5 -25t-61.5 -9zM516 14q24 0 49 7t46 20.5t34 32.5t13 43q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5zM557 214 q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5zM192 338q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5 t11.5 38.5q0 35 -33.5 55t-90.5 20h-21l4 18h21q70 0 108.5 23t38.5 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5 t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 755,
    d: "M34 11l679 700l13 -12l-679 -700zM509 -4q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5t-37 -15 q33 -10 53.5 -32.5t20.5 -54.5q0 -28 -14.5 -50.5t-37.5 -38.5t-53.5 -25t-61.5 -9zM515 14q24 0 49 7t46 20.5t34 32.5t13 43q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5zM556 214 q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5zM237 588q51 0 82.5 -27.5t31.5 -72.5q0 -32 -14.5 -59t-38.5 -46.5t-54.5 -30t-62.5 -10.5q-45 0 -75.5 21t-40.5 56l18 6 q10 -29 37 -47t66 -18q29 0 55 9.5t46 26t32 39t12 48.5q0 21 -8.5 37t-22.5 27t-32 16.5t-38 5.5q-32 0 -62.5 -13t-53.5 -36h-20q3 8 11 26t18 41t21 47t20 45t14.5 35t6.5 16h200l-4 -19h-184l-71 -162q24 20 53 29.5t58 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 753,
    d: "M-17 11l679 700l13 -12l-679 -700zM509 -4q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5t-37 -15 q33 -10 53.5 -32.5t20.5 -54.5q0 -28 -14.5 -50.5t-37.5 -38.5t-53.5 -25t-61.5 -9zM515 14q24 0 49 7t46 20.5t34 32.5t13 43q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5zM556 214 q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5zM374 711h-245l4 19h276l-296 -383h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 570,
    d: "M255 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 48 20 91t53.5 76t78.5 52.5t96 19.5q37 0 71.5 -11.5t62 -34t46.5 -55t27 -75.5q3 13 5 32t3.5 41t2.5 43.5t1 39.5q0 78 -14.5 132t-40.5 87t-63 47.5t-82 14.5q-59 0 -106.5 -20t-73.5 -51l-13 12q33 41 84.5 60 t108.5 19q109 0 164.5 -74t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM253 11q55 0 97 22t69.5 55.5t41.5 72.5t14 73q0 36 -15 68.5t-41 57t-61 39.5t-76 15q-45 0 -85.5 -17.5t-72 -47.5t-50 -70t-18.5 -84q0 -38 14.5 -71.5t40.5 -58.5t62 -39.5 t80 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 642,
    d: "M588 20v-20h-599v20l291 690h18zM566 20l-277 661l-278 -661h555z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 666,
    d: "M524 690h-341v-780h-20v780h-90v20h551v-20h-80v-780h-20v780z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 562,
    d: "M482 690h-378v-4l231 -317l-231 -340v-4h393v-25h-420v23l233 348l-230 317v22h402v-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 548,
    d: "M66 261v20h403v-20h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 542,
    d: "M-63 11l679 700l13 -12l-679 -700z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 155,
    d: "M56 250l18 83h19l-17 -83h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 376,
    d: "M24 365h97l93 -338l132 763h21l-136 -790h-31l-97 345h-79v20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 702,
    d: "M210 517q30 0 53 -11t40.5 -29t31 -42t25.5 -50q12 26 25.5 50t31 42t40.5 29t53 11q34 0 61.5 -13t47 -35.5t30 -53t10.5 -64.5t-11.5 -64t-31.5 -52.5t-47.5 -35.5t-59.5 -13q-29 0 -51.5 11t-40 29.5t-31 42.5t-24.5 50q-11 -26 -24.5 -50t-31.5 -42.5t-41.5 -29.5 t-54.5 -11q-32 0 -59.5 13t-47.5 35.5t-31.5 53t-11.5 64.5t11.5 64t31.5 52.5t47.5 35.5t59.5 13zM210 206q27 0 48 11.5t37.5 31t30 46t25.5 55.5q-12 30 -25.5 56.5t-30 47t-37.5 32t-48 11.5q-23 0 -46.5 -9t-42 -27t-30 -45.5t-11.5 -63.5q0 -35 11.5 -62.5t30 -46 t42 -28t46.5 -9.5zM510 206q23 0 46 9.5t41.5 28t30 46t11.5 62.5q0 36 -11.5 63t-30 45t-41.5 27t-46 9q-28 0 -49 -12t-37.5 -32.5t-29 -48t-23.5 -57.5q12 -29 25 -54t29.5 -44.5t37 -30.5t47.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 261,
    d: "M107 683q-2 23 -2 29v9q0 42 20.5 70.5t55.5 28.5q17 0 38 -6t38 -15l-7 -17q-7 4 -16 7.5t-19 6.5t-18.5 4.5t-14.5 1.5q-27 0 -42.5 -22t-15.5 -63v-8t2 -28l38 -708q2 -26 2 -32.5v-9.5q0 -47 -20 -72.5t-55 -25.5q-17 0 -37.5 6t-37.5 15l6 17q16 -8 35 -14t33 -6 q26 0 42 21t16 63v10.5t-2 30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 443,
    d: "M358 297q-12 -7 -26.5 -11t-32.5 -4q-27 0 -50 6.5t-43.5 14t-39 14t-36.5 6.5q-25 0 -45 -15l-13 16q10 8 25 13.5t33 5.5q23 0 44 -6.5t41 -14t40.5 -14t43.5 -6.5q14 0 25.5 1.5t21.5 9.5zM358 228q-12 -7 -26.5 -11t-32.5 -4q-27 0 -50 6.5t-43.5 14t-39 14 t-36.5 6.5q-25 0 -45 -15l-13 16q10 8 25 13.5t33 5.5q23 0 44 -6.5t41 -14t40.5 -14t43.5 -6.5q14 0 25.5 1.5t21.5 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 454,
    d: "M74 321h159l65 102h26l-65 -102h108v-20h-121l-32 -50h153v-20h-166l-65 -103h-25l65 103h-102v20h115l31 50h-146v20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 457,
    d: "M64 85v20h300v-20h-300zM64 365l290 149v-22l-261 -136l261 -137v-22l-290 150v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 470,
    d: "M73 105h300v-20h-300v20zM83 219l261 137l-261 136l-10 22l300 -149v-18l-290 -150v22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 465,
    d: "M258 730l186 -364l-186 -366h-24l-186 366l186 364h24zM416 354l-175 356l-165 -335l174 -350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 115,
    d: "M15 -167l22 58h-9l13 59h25l-12 -59l-25 -58h-14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 731,
    d: "M167 -10q-62 0 -103.5 24t-66.5 58l17 13q61 -75 159 -75q31 0 65 8t62.5 25t47.5 44t19 66q0 30 -12 47.5t-33 27.5t-49 14t-59 7q-29 3 -56 7t-47.5 15t-32.5 32t-12 57q0 47 20 79t51 51.5t68.5 28t72.5 8.5q70 0 108 -30q-5 24 -9.5 45t-4.5 47q0 27 7.5 56t27 53 t52 39.5t83.5 15.5q55 0 75.5 -20.5t20.5 -63.5q0 -29 -6.5 -65.5t-16.5 -84.5h118l-4 -20h-119l-90 -424q-1 -4 -1 -6.5v-4.5q0 -26 16.5 -37.5t40.5 -11.5q15 0 29.5 3.5t26 8t19 8.5t8.5 5l7 -16q-1 -1 -9 -5.5t-21.5 -10t-30 -9.5t-33.5 -4q-33 0 -53.5 17t-20.5 44 q0 9 2 19l90 424h-71l5 20h71q11 49 16.5 84.5t5.5 59.5q0 42 -18 56t-60 14q-47 0 -76 -13.5t-45 -34.5t-21.5 -47.5t-5.5 -52.5q0 -48 10.5 -82t15.5 -51l-20 -8q-8 19 -21 31.5t-29.5 19.5t-35.5 9.5t-37 2.5q-33 0 -66.5 -7.5t-60 -24t-43.5 -43.5t-17 -65 q0 -32 11.5 -50.5t30.5 -28.5t43.5 -14t49.5 -6q27 -2 56.5 -6t53.5 -15.5t40 -33.5t16 -59q0 -44 -21.5 -75t-54 -51t-71.5 -29t-74 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 557,
    d: "M324 540h18l124 -540h-21l-44 190h-285l-125 -190h-22zM397 209l-70 303l-200 -303h270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 544,
    d: "M144 540h247q25 0 43.5 -9.5t31 -25t19 -36t6.5 -41.5q0 -50 -30.5 -91t-78.5 -60q37 -12 57 -43.5t20 -69.5q0 -33 -15 -62.5t-39 -52t-55 -36t-64 -13.5h-257zM290 19q28 0 55 12.5t48 32.5t33.5 45.5t12.5 52.5q0 41 -24.5 71t-67.5 30h-242l-52 -244h237zM330 282 q28 0 53.5 12.5t44.5 32.5t30.5 45.5t11.5 51.5q0 39 -22 67.5t-63 28.5h-226l-50 -238h221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 571,
    d: "M246 -5q-49 0 -87 19.5t-64.5 52t-40 74.5t-13.5 86q0 54 24 110.5t67.5 102t103 74.5t130.5 29q74 0 118.5 -33.5t58.5 -84.5l-20 -8q-9 30 -26.5 50t-39 32.5t-47 18t-51.5 5.5q-66 0 -120.5 -27t-94 -69.5t-61.5 -95.5t-22 -104q0 -43 13.5 -81.5t38.5 -67.5t60.5 -46 t79.5 -17q27 0 56.5 6.5t59 20t56.5 35t49 50.5l17 -6q-21 -30 -50 -53.5t-62 -39.5t-67.5 -24.5t-65.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 590,
    d: "M144 540h179q54 0 94 -16t66 -44.5t38.5 -67t12.5 -82.5q0 -71 -24.5 -131.5t-68 -104.5t-103.5 -69t-130 -25h-179zM212 19q71 0 127 25t94.5 67.5t59 98.5t20.5 117q0 42 -12 77.5t-36.5 61t-61 40t-85.5 14.5h-159l-106 -501h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 508,
    d: "M144 540h357l-4 -20h-338l-50 -235h296l-4 -19h-296l-52 -247h344l-4 -19h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 504,
    d: "M144 540h356l-4 -20h-337l-49 -234h287l-4 -20h-288l-56 -266h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 705,
    d: "M297 -5q-58 0 -103.5 24t-77 64.5t-48 93.5t-16.5 111q0 81 34 158t90 137t128 96t148 36q42 0 77 -11.5t63 -32.5t49 -50t34 -63l-17 -14q-25 67 -79.5 109t-132.5 42q-75 0 -142.5 -36t-119 -94t-82 -130.5t-30.5 -145.5q0 -54 15.5 -104t45.5 -87.5t73 -60t97 -22.5 q60 0 115 24.5t101.5 65.5t82 94t54.5 110h-233l4 20h255q-1 -5 -2.5 -9.5t-3.5 -11.5q-21 -62 -59.5 -118.5t-88.5 -99.5t-109.5 -69t-121.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 591,
    d: "M465 90q-104 -94 -217 -94q-50 0 -88.5 19.5t-65 51.5t-40.5 73t-14 85q0 58 25.5 115t69 102t101 73t120.5 28q43 0 74.5 -8.5t54 -24.5t36.5 -37.5t22 -46.5l-20 -8q-19 57 -63.5 81.5t-107.5 24.5q-61 0 -114.5 -27t-93 -70t-62 -95.5t-22.5 -104.5q0 -43 14 -81 t39 -67t60.5 -46t79.5 -17q54 0 107.5 24t110.5 76l26 123h-129l4 19h149l-55 -258h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 604,
    d: "M144 540h20l-54 -254h378l54 254h20l-115 -540h-20l56 266h-378l-56 -266h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 206,
    d: "M144 539h19l-114 -539h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 403,
    d: "M86 -8q-71 0 -113 33l13 16q38 -30 104 -30q49 0 81.5 17.5t54.5 50t36.5 79.5t27.5 107l58 274h20l-58 -274q-13 -62 -29 -112t-41 -86t-62 -55.5t-92 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 515,
    d: "M144 539h19l-73 -345l420 346h28l-286 -236l182 -304h-25l-174 290l-150 -122l-36 -168h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 473,
    d: "M144 540h20l-111 -521h344l-4 -19h-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 721,
    d: "M144 540h17l164 -409l337 409h17l-115 -540h-19l105 498l-323 -392h-15l-157 392l-106 -498h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 638,
    d: "M144 540h15l309 -509l107 508h20l-114 -539h-22l-304 501l-106 -501h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 622,
    d: "M247 -4q-50 0 -88.5 18.5t-64.5 50t-40 72.5t-14 85q0 61 27.5 119t72.5 103t103 72t120 27q49 0 87.5 -19t64.5 -51t39.5 -73t13.5 -84q0 -61 -27 -118.5t-71.5 -102.5t-102.5 -72t-120 -27zM251 16q60 0 114 26.5t94.5 69.5t64.5 96t24 106q0 42 -13 80t-38 67t-60 46 t-78 17q-60 0 -114 -26.5t-95 -69.5t-65 -96t-24 -107q0 -42 13 -79.5t37.5 -66.5t59.5 -46t80 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 515,
    d: "M144 540h225q30 0 53 -11.5t39.5 -31t25 -44.5t8.5 -51q0 -35 -15 -69.5t-41 -61.5t-60.5 -44t-73.5 -17h-211l-45 -210h-20zM309 230q35 0 65.5 15.5t52.5 40t34.5 54.5t12.5 59q0 24 -8 46t-22 38.5t-34 26.5t-45 10h-206l-61 -290h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 621,
    d: "M421 54q-39 -27 -83 -42.5t-91 -15.5q-50 0 -88.5 18.5t-64.5 50t-40 72.5t-14 85q0 61 27 119t72 103t103.5 72t120.5 27q49 0 87 -19t64.5 -51t40 -73t13.5 -84q0 -36 -9.5 -71t-27 -67t-41.5 -60.5t-53 -51.5l41 -66h-24zM251 16q44 0 84.5 14.5t75.5 39.5l-44 75h23 l37 -62q27 22 49 49t38 57t24.5 61.5t8.5 63.5q0 42 -13 80t-37.5 67t-59.5 46t-78 17q-60 0 -114.5 -26.5t-95.5 -69.5t-65 -96t-24 -107q0 -42 13 -79.5t38 -66.5t60 -46t80 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 534,
    d: "M144 540h226q30 0 53 -11.5t39.5 -31t25 -44.5t8.5 -51q0 -34 -14 -67t-38.5 -59t-57 -43.5t-68.5 -20.5l95 -212h-24l-94 210h-201l-45 -210h-20zM309 230q34 0 64.5 15t53 39.5t35.5 55t13 60.5q0 24 -8 45.5t-22 38t-34.5 26.5t-45.5 10h-206l-61 -290h211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 504,
    d: "M198 -4q-66 0 -114 20.5t-84 62.5l17 14q32 -41 77 -60.5t109 -19.5q44 0 81 8.5t64 26t42 44t15 61.5q0 46 -39 69t-119 39q-39 7 -69 16t-51 21.5t-32 31t-11 44.5q0 40 17 71t47 53t72 33.5t92 11.5q53 0 89.5 -14.5t62.5 -49.5l-15 -15q-25 35 -57.5 48t-82.5 13 q-54 0 -93 -11.5t-64 -31t-36.5 -46.5t-11.5 -58q0 -22 9 -37t27.5 -26.5t47 -19.5t66.5 -16q39 -8 70.5 -17t54 -22.5t35 -33.5t12.5 -48q0 -39 -16.5 -69t-46.5 -50.5t-72 -31.5t-93 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 495,
    d: "M283 520h-211l4 20h441l-5 -20h-209l-111 -520h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 621,
    d: "M247 -4q-51 0 -85.5 14.5t-55.5 39t-30 57.5t-9 71q0 43 11 92l57 270h20l-57 -270q-5 -23 -7.5 -45.5t-2.5 -43.5q0 -35 8 -65t27 -52t50 -35t77 -13q61 0 106 22t76.5 58t51 81.5t29.5 92.5l57 270h19l-57 -270q-12 -54 -34 -103.5t-56.5 -87.5t-83 -60.5t-111.5 -22.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 556,
    d: "M76 540h21l120 -514l337 514h22l-355 -540h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 972,
    d: "M107 710h21l62 -685l362 685h22l80 -685l353 685h22l-369 -710h-22l-81 678l-361 -678h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 838,
    d: "M76 540h22l120 -515l189 288l-51 222h21l45 -201l132 201h21l-146 -222l68 -288l339 515h22l-355 -540h-21l-68 292l-192 -292h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 512,
    d: "M236 266l-164 274h25l155 -258l264 258h25l-280 -274l159 -266h-24l-151 250l-256 -250h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 515,
    d: "M224 209l-152 331h23l143 -311l277 311h23l-294 -332l-45 -208h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 512,
    d: "M-25 19l524 501h-414l5 20h438l-4 -19l-524 -502h414l-4 -19h-439z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 580,
    d: "M214 -10q-44 0 -78 18t-57.5 48.5t-36 70t-12.5 81.5q0 62 26 119.5t68 102t95.5 71t108.5 26.5q67 0 110.5 -37t61.5 -93l25 120h20l-110 -517h-20l26 119q-43 -57 -102.5 -93t-124.5 -36zM219 10q36 0 70 12.5t64 34t55 50t43 60.5l39 184q-5 33 -18.5 61.5t-35 49.5 t-50 33t-62.5 12q-55 0 -105 -27t-87.5 -70t-59.5 -96t-22 -104q0 -40 11.5 -76.5t33 -64t53 -43.5t71.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 501,
    d: "M131 -10q-29 0 -53 10t-41 27.5t-26.5 41.5t-9.5 52q0 50 24 84t59.5 54.5t77.5 29t78 8.5q60 0 100.5 -10.5t57.5 -18.5l13 59q6 25 6 50q0 59 -33.5 94.5t-95.5 35.5q-36 0 -80.5 -16.5t-92.5 -47.5l-8 16q45 28 92 48t93 20q74 0 109.5 -40.5t35.5 -103.5 q0 -28 -6 -56l-70 -327h-20l19 88q-49 -51 -110.5 -74.5t-118.5 -23.5zM135 10q27 0 56.5 5.5t58 16.5t54 28.5t45.5 41.5q18 21 23 41l22 103q-38 17 -77.5 24t-81.5 7q-33 0 -71 -7.5t-69.5 -25t-52.5 -47t-21 -73.5q0 -26 9 -47t24.5 -36t36 -23t44.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 787,
    d: "M217 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 58 24 114.5t64 101.5t93 72.5t112 27.5q47 0 79 -12t52 -34q-9 20 -17.5 48.5t-8.5 60.5q0 31 11 60.5t31.5 52.5t49.5 36.5t64 13.5q63 0 86 -23.5t23 -68.5q0 -29 -6.5 -64.5t-15.5 -77.5h118l-4 -20h-119 l-90 -424q-1 -3 -1 -9q0 -25 16 -38t39 -13t44 7t41 18l7 -16q-29 -14 -48.5 -21.5t-48.5 -7.5q-31 0 -51 17t-20 46q0 4 0.5 8t1.5 9l90 424h-71l4 20h72q7 35 14 68t7 61q0 38 -19.5 61.5t-73.5 23.5q-32 0 -56 -12t-41 -31.5t-25.5 -44t-8.5 -50.5q0 -25 6 -53 t13.5 -53.5t14.5 -46t9 -31.5l-20 -7q-17 54 -57 78.5t-96 24.5q-57 0 -106 -27.5t-85 -70.5t-56.5 -95t-20.5 -101q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5q23 0 52.5 7.5t57.5 22t51 34.5t35 45l18 -6q-16 -30 -42 -53t-56 -38.5t-61.5 -23.5t-58.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 188,
    d: "M40 657l76 73h33l-96 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    horizAdvX: 577,
    d: "M218 -10q-44 0 -79 18.5t-59 49t-36.5 70.5t-12.5 83q0 60 24 116.5t64.5 101t93.5 71.5t110 27q34 0 61 -10.5t48 -28t37 -41t28 -49.5l70 332h20l-155 -730h-20l23 108q-21 -26 -47 -47.5t-54.5 -37.5t-58 -24.5t-57.5 -8.5zM222 10q29 0 64.5 13t68.5 34.5t58.5 50.5 t34.5 61l40 187q-3 31 -19 58.5t-39 48t-52 32.5t-59 12q-55 0 -104 -26.5t-85.5 -68.5t-57.5 -94.5t-21 -104.5q0 -41 12 -78t34.5 -64.5t54 -44t70.5 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 557,
    d: "M485 220q0 -51 -24 -93t-62.5 -71.5t-88 -46t-100.5 -16.5q-45 0 -79.5 13.5t-58 36t-35.5 53t-12 63.5q0 43 18.5 79.5t47 65t64 48.5t70.5 29q-42 17 -71 51t-29 83q0 46 22 82.5t57 61.5t77.5 38t84.5 13q33 0 63.5 -9.5t53.5 -27.5t37 -44t14 -60q0 -36 -14.5 -65.5 t-38 -53t-54 -41t-62.5 -28.5q53 -17 86.5 -59.5t33.5 -101.5zM465 219q0 36 -15 64t-39.5 47.5t-55.5 30t-63 10.5q-41 0 -84.5 -15t-79.5 -43t-59.5 -66.5t-23.5 -85.5q0 -36 15 -64t39.5 -47.5t55.5 -29.5t63 -10q41 0 84.5 15t79.5 42.5t59.5 66t23.5 85.5zM145 517 q0 -30 13.5 -53.5t35 -39.5t48.5 -24.5t55 -8.5q34 0 72.5 11.5t70.5 34t53 55t21 73.5q0 30 -12.5 53t-33.5 39t-49 24.5t-59 8.5q-39 0 -77 -12t-69 -34.5t-50 -54.5t-19 -72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 533,
    d: "M194 -10q-72 0 -120 40t-62 106h21q14 -57 58 -91.5t107 -34.5q48 0 94 19t81.5 52.5t57 79.5t21.5 99q0 36 -12 66.5t-33 52.5t-50.5 34t-65.5 12q-54 0 -107 -25t-95 -73h-24q4 9 12.5 30t20 49.5t25 62t27.5 67.5q32 79 71 174h320l-4 -20h-304l-130 -325 q42 39 92 59.5t101 20.5q39 0 71 -13.5t55.5 -37.5t36.5 -57.5t13 -73.5q0 -60 -24.5 -110t-63.5 -86t-89 -56.5t-101 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 527,
    d: "M327 0l45 211h-365l4 17l473 482h14l-102 -479h84l-4 -20h-84l-45 -211h-20zM376 231l94 442l-431 -442h337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 182,
    d: "M127 517h20l-155 -730h-20zM170 717h20l-14 -64h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 198,
    d: "M180 730h20l-155 -730h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 580,
    d: "M75 429q0 58 24.5 110t65.5 91t93 62t108 23q42 0 76.5 -14.5t59 -42t38 -67t13.5 -88.5q0 -97 -25 -189.5t-70 -164.5t-108.5 -115.5t-139.5 -43.5q-69 0 -113.5 39.5t-51.5 107.5l20 7q3 -30 15 -54.5t31.5 -42.5t45.5 -27.5t56 -9.5q49 0 95 26t85 75.5t70 121.5 t51 164q-19 -37 -47 -68t-62 -53t-71.5 -34t-74.5 -12q-41 0 -75 15.5t-58 42.5t-37.5 63t-13.5 78zM360 695q-50 0 -97 -21t-84.5 -57t-60 -83t-22.5 -99q0 -38 12.5 -72t35 -59t53.5 -39.5t69 -14.5q49 0 97 21.5t85 57.5t60 83.5t23 98.5q0 38 -12.5 71.5t-35 58.5 t-54 39.5t-69.5 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 336,
    d: "M1 20h126l141 667q-10 -12 -30 -26.5t-43.5 -28t-48 -22.5t-43.5 -9l4 20q25 0 54 15t54 33t42 33.5t18 17.5h21l-149 -700h120l-4 -20h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    horizAdvX: 576,
    d: "M436 119q-55 -63 -112.5 -96t-115.5 -33q-44 0 -77.5 18t-56 47.5t-34 68.5t-11.5 81q0 62 26 120t68.5 103t96.5 72t111 27q29 0 55 -9t48 -25t38.5 -37.5t25.5 -46.5l23 110h20l-155 -732h-20zM212 10q35 0 68.5 12.5t63 33.5t55.5 48t46 57l45 204q-3 27 -16 52.5 t-34 45.5t-50 32t-63 12q-55 0 -105 -26.5t-88.5 -69t-61.5 -96t-23 -107.5q0 -40 11 -76t32 -63t51.5 -43t68.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 463,
    d: "M505 690h-404l4 20h438l-497 -710h-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 581,
    d: "M237 -10q-42 0 -76.5 14.5t-59.5 42t-38.5 67t-13.5 88.5q0 97 25 189.5t70.5 164.5t108.5 115.5t140 43.5q69 0 113.5 -39.5t50.5 -107.5l-20 -7q-3 30 -14.5 54.5t-31 42.5t-45.5 27.5t-57 9.5q-49 0 -94.5 -26t-85 -75.5t-70.5 -121.5t-51 -164q19 37 47.5 68t62 53 t71 34t75.5 12q41 0 75 -15.5t58 -42.5t37.5 -63t13.5 -78q0 -58 -24.5 -110t-65.5 -91t-93.5 -62t-107.5 -23zM243 10q49 0 96.5 21t85 57t60 83t22.5 99q0 38 -12.5 72t-35.5 59t-54.5 39.5t-68.5 14.5q-50 0 -97.5 -21.5t-84.5 -57.5t-60 -83.5t-23 -98.5 q0 -38 12.5 -71.5t35.5 -58.5t54.5 -39.5t69.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 264,
    d: "M139 499h-71l4 20h71l39 182h20l-39 -182h119l-4 -20h-119l-106 -499h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 555,
    d: "M217 -9q-42 0 -77.5 12t-61.5 35t-40.5 58t-14.5 80h20q0 -41 14 -72t38.5 -51.5t57 -31t69.5 -10.5q46 0 89 15t76 41.5t52.5 61.5t19.5 76q0 66 -53 105.5t-147 39.5h-33l4 20h34q121 0 185 48t64 130q0 69 -44 110t-119 41q-66 0 -122.5 -31t-88.5 -84l-16 8 q35 58 98 92.5t134 34.5q40 0 73.5 -12t56.5 -34.5t36 -53.5t13 -68q0 -72 -45.5 -121t-130.5 -71q58 -12 90 -53t32 -96q0 -46 -22 -86t-59 -69.5t-84 -46.5t-98 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 533,
    d: "M-12 0q10 69 34 120.5t58.5 89.5t77 64.5t89.5 44.5q43 16 90 32.5t86 41.5t64.5 63.5t25.5 100.5q0 28 -8.5 53.5t-26.5 45t-46 31.5t-67 12q-44 0 -80.5 -12.5t-65 -30.5t-49 -38t-33.5 -35l-14 10q0 1 17.5 21t50 43t78 42.5t102.5 19.5q43 0 73.5 -13.5t50.5 -35.5 t29.5 -51t9.5 -60q0 -68 -29 -111t-72 -70t-92 -44t-89 -33q-70 -27 -114.5 -63.5t-71 -75t-38 -76t-16.5 -66.5h411l-4 -20h-431z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 549,
    d: "M171 -10q-36 0 -60 10.5t-38 28.5t-20 42.5t-6 52.5q0 25 3.5 51.5t9.5 52.5l62 291h20l-62 -291q-6 -27 -9.5 -52t-3.5 -48q0 -26 5.5 -47.5t18 -37.5t33 -24.5t51.5 -8.5q38 0 75.5 15t70.5 40t59.5 57t43.5 67l71 330h20l-111 -519h-20l28 132q-22 -32 -50 -58 t-60 -44.5t-65.5 -29t-65.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 755,
    d: "M70 519h22l60 -489l258 489h22l50 -489l268 489h22l-287 -519h-18l-51 493l-261 -493h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 487,
    d: "M172 0l-118 519h21l112 -494l311 494h21l-458 -732h-18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 642,
    d: "M255 -10q-53 0 -91.5 25t-63 65.5t-36 91t-11.5 100.5q0 75 28.5 152.5t77 141t113 104t136.5 40.5q54 0 92 -25.5t62 -66.5t35.5 -91.5t11.5 -99.5q0 -75 -28 -152.5t-76.5 -141t-113 -103.5t-136.5 -40zM259 10q72 0 132.5 41t104.5 103t68.5 134.5t24.5 135.5 q0 49 -11.5 97t-34.5 85.5t-57.5 60.5t-81.5 23q-72 0 -132 -42t-104 -106t-68.5 -138.5t-24.5 -140.5q0 -50 10.5 -95.5t33 -80.5t57 -56t83.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 115,
    d: "M21 -127l16 77h20l-16 -77h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 421,
    d: "M146 -5q-35 0 -60 14t-41 36.5t-23.5 51t-7.5 56.5q0 39 17 80t46 74.5t68 54.5t83 21q34 0 59 -14.5t41 -37t23.5 -50.5t7.5 -56q0 -40 -16.5 -81t-45.5 -74t-67.5 -54t-83.5 -21zM150 14q42 0 77 20.5t59.5 52t38.5 67.5t14 68q0 26 -7 51.5t-21.5 45.5t-36 32.5 t-50.5 12.5q-42 0 -77 -20.5t-60 -52t-39 -68t-14 -68.5q0 -26 7 -51.5t21.5 -45.5t36 -32t51.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 240,
    d: "M-12 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33.5 18t26 18.5t11.5 9.5h19l-78 -370h74l-4 -19h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 354,
    d: "M-23 0q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5t-69 22.5q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12 12.5t31.5 22.5t48.5 22t62 10q56 0 80.5 -26.5t24.5 -62.5q0 -37 -17 -60t-42.5 -38t-54 -24t-52.5 -17 q-41 -14 -66 -32t-40 -37.5t-21.5 -38t-9.5 -33.5h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 363,
    d: "M115 -5q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33 55t-91 20h-21l4 18h21q69 0 108 23t39 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48t82.5 18 q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 352,
    d: "M207 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM211 129l47 219l-241 -219h194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 350,
    d: "M105 -5q-45 0 -75.5 21t-40.5 56l18 6q10 -29 37.5 -47t65.5 -18q29 0 55 9.5t46 26t32 39t12 48.5q0 21 -8.5 37t-22.5 27t-32 16.5t-38 5.5q-32 0 -62.5 -13t-53.5 -36h-20q3 8 11 26t18 41t21 47t20 45t14.5 35t6.5 16h200l-4 -19h-184l-71 -162q24 20 53 29.5t58 9.5 q51 0 82.5 -27.5t31.5 -72.5q0 -32 -14.5 -59t-38.5 -46.5t-54.5 -30t-62.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 380,
    d: "M132 -5q-54 0 -87 32t-33 89q0 55 15 104t42.5 86t65 58.5t82.5 21.5q42 0 71 -20.5t35 -55.5l-17 -10q-5 30 -30 49t-62 19q-59 0 -106 -50.5t-67 -144.5q22 38 63.5 60.5t86.5 22.5q52 0 84.5 -31.5t32.5 -77.5q0 -31 -14.5 -58.5t-39 -48.5t-56.5 -33t-66 -12zM137 13 q29 0 56.5 10.5t48.5 28t34 41t13 49.5q0 40 -29.5 68.5t-75.5 28.5q-29 0 -56.5 -10.5t-48.5 -28.5t-34 -41.5t-13 -49.5q0 -40 29.5 -68t75.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 313,
    d: "M282 364h-245l4 19h276l-296 -383h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 366,
    d: "M117 -4q-57 0 -88 28t-31 66q0 22 10.5 41t27 34t37.5 25t41 16q-26 9 -43.5 27.5t-17.5 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8.5 -33.5t-22 -28t-31.5 -21.5t-37 -15q33 -10 53.5 -32.5t20.5 -54.5q0 -28 -14.5 -50.5 t-37.5 -38.5t-53.5 -25t-61.5 -9zM123 14q24 0 49 7t46 20.5t34 32.5t13 43q0 19 -9 33.5t-24 25t-34 16t-38 5.5q-24 0 -49 -7.5t-46 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5zM164 214q20 0 42 6t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17 q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 380,
    d: "M116 -5q-43 0 -71.5 20.5t-34.5 55.5l17 10q5 -31 30 -49.5t62 -18.5q59 0 106 50.5t67 143.5q-22 -37 -63.5 -60t-86.5 -23q-53 0 -85.5 32t-32.5 78q0 31 15 58.5t39.5 48.5t56.5 33t66 12q54 0 87 -32t33 -89q0 -55 -15 -104t-42 -86t-64.5 -58.5t-83.5 -21.5z M149 142q29 0 56.5 10.5t48.5 28.5t34 41.5t13 49.5q0 19 -8 36.5t-22 31t-33 21t-42 7.5q-29 0 -56 -10.5t-48 -28t-34 -41t-13 -49.5q0 -41 29 -69t75 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 420,
    d: "M219 342q-35 0 -60 14t-41 36.5t-23.5 51t-7.5 56.5q0 39 17 80t46 74.5t68 54.5t83 21q34 0 59 -14.5t41 -37t23.5 -50.5t7.5 -56q0 -40 -16.5 -81t-45.5 -74t-67.5 -54t-83.5 -21zM107 502q0 -26 7 -51.5t21.5 -45.5t36 -32t51.5 -12q42 0 77 20.5t59.5 52t38.5 67.5 t14 68q0 26 -7 51.5t-21.5 45.5t-36 32.5t-50.5 12.5q-42 0 -77 -20.5t-60 -52t-39 -68t-14 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 240,
    d: "M233 361l-4 -19h-172l4 19h79l73 344q-6 -6 -18.5 -14.5t-27 -15.5t-29.5 -12t-27 -5l4 19q15 0 33 8t33 18t25.5 18.5t11.5 9.5h20l-79 -370h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 354,
    d: "M50 343q16 74 55.5 113t98.5 60q25 9 53 18t51 22t38 32.5t15 49.5q0 29 -21 51.5t-69 22.5q-26 0 -47.5 -6.5t-38.5 -15.5t-29.5 -19.5t-20.5 -18.5l-12 12q1 2 12.5 12.5t31.5 22.5t47.5 22t62.5 10q56 0 80.5 -26.5t24.5 -62.5t-17 -59.5t-42.5 -38.5t-54 -24 t-52.5 -17q-40 -14 -65.5 -32t-40.5 -37t-21.5 -38t-9.5 -34h246l-4 -19h-271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 363,
    d: "M188 338q-19 0 -40.5 5.5t-39.5 17t-29.5 29.5t-11.5 44l17 7q0 -35 28.5 -59.5t79.5 -24.5q28 0 53.5 7.5t44.5 20.5t30.5 30.5t11.5 38.5q0 35 -33.5 55t-90.5 20h-21l4 18h21q70 0 108.5 23t38.5 67q0 34 -27 55t-72 21q-40 0 -74 -17t-51 -43l-12 12q20 30 58.5 48 t82.5 18q53 0 84.5 -26t31.5 -65q0 -38 -26 -64.5t-79 -37.5q36 -7 56.5 -29.5t20.5 -52.5q0 -26 -13.5 -47.5t-36 -37t-52.5 -24.5t-62 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 353,
    d: "M258 347l23 110h-221l4 17l281 256h14l-54 -254h52l-4 -19h-52l-24 -110h-19zM91 476h194l47 219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 350,
    d: "M235 588q51 0 82.5 -27.5t31.5 -72.5q0 -32 -14.5 -59t-38.5 -46.5t-54.5 -30t-62.5 -10.5q-45 0 -75.5 21t-40.5 56l18 6q10 -29 37 -47t66 -18q29 0 55 9.5t46 26t32 39t12 48.5q0 21 -8.5 37t-22.5 27t-32 16.5t-38 5.5q-32 0 -62.5 -13t-53.5 -36h-20q3 8 11 26 t18 41t21 47t20 45t14.5 35t6.5 16h200l-4 -19h-184l-71 -162q24 20 53 29.5t58 9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 379,
    d: "M381 491q0 -31 -14.5 -58.5t-39 -48.5t-56.5 -33t-66 -12q-54 0 -87 32t-33 89q0 55 15 104t42.5 86t65 58.5t82.5 21.5q42 0 71 -20.5t35 -55.5l-17 -10q-5 30 -30 49t-62 19q-59 0 -106 -50.5t-67 -144.5q22 38 63.5 60.5t86.5 22.5q52 0 84.5 -31.5t32.5 -77.5z M210 357q29 0 56.5 10.5t48.5 28t34 41t13 49.5q0 40 -29.5 68.5t-75.5 28.5q-29 0 -56.5 -10.5t-48.5 -28.5t-34 -41.5t-13 -49.5q0 -40 29.5 -68t75.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 312,
    d: "M356 711h-245l4 19h276l-296 -383h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 367,
    d: "M359 466q0 -28 -14.5 -50.5t-38 -38.5t-54 -25t-61.5 -9q-57 0 -88 28t-31 66q0 22 10.5 41t27.5 34t38 25t41 16q-26 9 -44 27.5t-18 44.5q0 25 13.5 44.5t35 33t47.5 20.5t52 7q21 0 40.5 -5t34.5 -15t24 -25t9 -34q0 -18 -8 -33.5t-21.5 -28t-31.5 -21.5t-37 -15 q32 -10 53 -32.5t21 -54.5zM339 464q0 19 -9 33.5t-24 25t-33.5 16t-37.5 5.5q-24 0 -49.5 -7.5t-46.5 -21.5t-34 -33.5t-13 -42.5q0 -18 9 -32.5t24 -24.5t34 -15.5t38 -5.5q24 0 49 7t46 20.5t34 32.5t13 43zM147 626q0 -15 8 -27.5t21 -20.5t29 -12.5t33 -4.5q20 0 42 6 t40.5 17t30.5 27t12 36q0 31 -28 48t-65 17q-23 0 -45 -6t-39 -17.5t-28 -27.5t-11 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 380,
    d: "M98 578q0 31 14.5 58.5t39 48.5t56.5 33t66 12q54 0 87 -32t33 -89q0 -55 -14.5 -104t-41.5 -86t-65 -58.5t-84 -21.5q-42 0 -71 20.5t-35 55.5l17 10q5 -31 30 -49.5t63 -18.5q58 0 105 50.5t67 143.5q-22 -37 -63.5 -60t-86.5 -23q-52 0 -84.5 32t-32.5 78zM269 712 q-29 0 -56 -10.5t-48 -28t-34 -41t-13 -49.5q0 -41 29 -69t75 -28q29 0 56.5 10.5t48.5 28.5t34 41.5t13 49.5q0 19 -8 36.5t-22 31t-33 21t-42 7.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u0129",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "five.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xD7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "X",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xD7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "=",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u1EF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012B",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "U.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0166",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0142",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0141",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0110",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "w.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    g2: "T.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xA6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "|",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "|",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xA6",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "|",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "*",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "a",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\xA6",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "|",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\xA6",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "|",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "q.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "d.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    g2: "a.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xE1",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xA6",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "|",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "g",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "d",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "a",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "]",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "/",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ")",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    g2: "y.alt",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "y",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "x",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014A",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2014",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2013",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "-",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: " ",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u012B",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0129",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0166",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "four.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u012B",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\u0129",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0149",
    k: -125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEC",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u0149",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_i",
    u2: "\u012B",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_l",
    u2: "\u0149",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "|",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "|",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2120",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xA6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "|",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "|",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: " ",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "|",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xA6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\xA6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "|",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "|",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "five.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "bar",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "brokenbar",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eight",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "trademark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.alt2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ae,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "bar",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "brokenbar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "six",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "zero",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "ae,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Z.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "bar",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "brokenbar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ae,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bar",
    k: -19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "brokenbar",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "w.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "bar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "brokenbar",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "eth",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "bar",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "brokenbar",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "bar",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "brokenbar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "ordmasculine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "ae,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "bar",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "brokenbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "bar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "question",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "ae,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "ae,aeacute,a.alt2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "ae,aeacute,a.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H.sc,I.sc,M.sc,N.sc",
    g2: "question",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "bar",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "brokenbar",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "ae,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quoteright,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bar",
    g2: "AE,AEacute",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "brokenbar",
    g2: "AE,AEacute",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "nine.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "six.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B.sc,D.sc,E.sc,F.sc,H.sc,I.sc,K.sc,L.sc,M.sc,N.sc,P.sc,R.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "ae,aeacute,a.alt2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "ae,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,G.sc,O.sc,Q.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "a,d,g,q,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,aringacute,ddotbelow,a.alt,d.alt,q.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayThinItalic);
export default __webpack_public_path__ + "static/media/Raleway-ThinItalic.d98f39b6971a5d63f21012443612dd54.svg";
export { ForwardRef as ReactComponent };